export default [
  {
    name: 'New York',
    slug: 'new-york',
    abbreviation: 'NY',
    'new-york-city': {
      name: 'New York City'
    },
    buffalo: {
      name: 'Buffalo'
    },
    rochester: {
      name: 'Rochester'
    },
    yonkers: {
      name: 'Yonkers'
    },
    syracuse: {
      name: 'Syracuse'
    },
    albany: {
      name: 'Albany'
    },
    'new-rochelle': {
      name: 'New Rochelle'
    },
    'mount-vernon': {
      name: 'Mount Vernon'
    },
    schenectady: {
      name: 'Schenectady'
    },
    utica: {
      name: 'Utica'
    },
    'white-plains': {
      name: 'White Plains'
    },
    hempstead: {
      name: 'Hempstead'
    },
    'niagara-falls': {
      name: 'Niagara Falls'
    },
    troy: {
      name: 'Troy'
    },
    binghamton: {
      name: 'Binghamton'
    },
    freeport: {
      name: 'Freeport'
    },
    'valley-stream': {
      name: 'Valley Stream'
    },
    rome: {
      name: 'Rome'
    },
    'long-beach': {
      name: 'Long Beach'
    },
    poughkeepsie: {
      name: 'Poughkeepsie'
    },
    'north-tonawanda': {
      name: 'North Tonawanda'
    },
    'spring-valley': {
      name: 'Spring Valley'
    },
    jamestown: {
      name: 'Jamestown'
    },
    ithaca: {
      name: 'Ithaca'
    },
    elmira: {
      name: 'Elmira'
    },
    'port-chester': {
      name: 'Port Chester'
    },
    newburgh: {
      name: 'Newburgh'
    },
    middletown: {
      name: 'Middletown'
    },
    auburn: {
      name: 'Auburn'
    },
    harrison: {
      name: 'Harrison'
    },
    lindenhurst: {
      name: 'Lindenhurst'
    },
    watertown: {
      name: 'Watertown'
    },
    'glen-cove': {
      name: 'Glen Cove'
    },
    'saratoga-springs': {
      name: 'Saratoga Springs'
    },
    ossining: {
      name: 'Ossining'
    },
    'rockville-center': {
      name: 'Rockville Center'
    },
    kingston: {
      name: 'Kingston'
    },
    peekskill: {
      name: 'Peekskill'
    },
    'garden-city': {
      name: 'Garden City'
    },
    lockport: {
      name: 'Lockport'
    },
    'kiryas-joel': {
      name: 'Kiryas Joel'
    },
    plattsburg: {
      name: 'Plattsburg'
    },
    lynbrook: {
      name: 'Lynbrook'
    },
    cortland: {
      name: 'Cortland'
    },
    mamaroneck: {
      name: 'Mamaroneck'
    },
    mineola: {
      name: 'Mineola'
    },
    amsterdam: {
      name: 'Amsterdam'
    },
    oswego: {
      name: 'Oswego'
    },
    lackawanna: {
      name: 'Lackawanna'
    },
    scarsdale: {
      name: 'Scarsdale'
    }
  },
  {
    name: 'California',
    slug: 'california',
    abbreviation: 'CA',
    'los-angeles': {
      name: 'Los Angeles'
    },
    'san-diego': {
      name: 'San Diego'
    },
    'san-jose': {
      name: 'San Jose'
    },
    'san-francisco': {
      name: 'San Francisco'
    },
    fresno: {
      name: 'Fresno'
    },
    sacramento: {
      name: 'Sacramento'
    },
    'long-beach': {
      name: 'Long Beach'
    },
    oakland: {
      name: 'Oakland'
    },
    bakersfield: {
      name: 'Bakersfield'
    },
    anaheim: {
      name: 'Anaheim'
    },
    'santa-ana': {
      name: 'Santa Ana'
    },
    riverside: {
      name: 'Riverside'
    },
    stockton: {
      name: 'Stockton'
    },
    'chula-vista': {
      name: 'Chula Vista'
    },
    fremont: {
      name: 'Fremont'
    },
    irvine: {
      name: 'Irvine'
    },
    'san-bernardino': {
      name: 'San Bernardino'
    },
    modesto: {
      name: 'Modesto'
    },
    oxnard: {
      name: 'Oxnard'
    },
    fontana: {
      name: 'Fontana'
    },
    'moreno-valley': {
      name: 'Moreno Valley'
    },
    glendale: {
      name: 'Glendale'
    },
    'huntington-beach': {
      name: 'Huntington Beach'
    },
    'santa-clarita': {
      name: 'Santa Clarita'
    },
    'garden-grove': {
      name: 'Garden Grove'
    },
    'santa-rosa': {
      name: 'Santa Rosa'
    },
    oceanside: {
      name: 'Oceanside'
    },
    'rancho-cucamonga': {
      name: 'Rancho Cucamonga'
    },
    ontario: {
      name: 'Ontario'
    },
    lancaster: {
      name: 'Lancaster'
    },
    'elk-grove': {
      name: 'Elk Grove'
    },
    palmdale: {
      name: 'Palmdale'
    },
    corona: {
      name: 'Corona'
    },
    salinas: {
      name: 'Salinas'
    },
    pomona: {
      name: 'Pomona'
    },
    torrance: {
      name: 'Torrance'
    },
    hayward: {
      name: 'Hayward'
    },
    escondido: {
      name: 'Escondido'
    },
    sunnyvale: {
      name: 'Sunnyvale'
    },
    pasadena: {
      name: 'Pasadena'
    },
    orange: {
      name: 'Orange'
    },
    fullerton: {
      name: 'Fullerton'
    },
    'thousand-oaks': {
      name: 'Thousand Oaks'
    },
    visalia: {
      name: 'Visalia'
    },
    'simi-valley': {
      name: 'Simi Valley'
    },
    concord: {
      name: 'Concord'
    },
    roseville: {
      name: 'Roseville'
    },
    'santa-clara': {
      name: 'Santa Clara'
    },
    vallejo: {
      name: 'Vallejo'
    },
    victorville: {
      name: 'Victorville'
    }
  },
  {
    name: 'Illinois',
    slug: 'illinois',
    abbreviation: 'IL',
    chicago: {
      name: 'Chicago'
    },
    aurora: {
      name: 'Aurora'
    },
    rockford: {
      name: 'Rockford'
    },
    joliet: {
      name: 'Joliet'
    },
    naperville: {
      name: 'Naperville'
    },
    springfield: {
      name: 'Springfield'
    },
    peoria: {
      name: 'Peoria'
    },
    elgin: {
      name: 'Elgin'
    },
    waukegan: {
      name: 'Waukegan'
    },
    cicero: {
      name: 'Cicero'
    },
    champaign: {
      name: 'Champaign'
    },
    bloomington: {
      name: 'Bloomington'
    },
    decatur: {
      name: 'Decatur'
    },
    'arlington-heights': {
      name: 'Arlington Heights'
    },
    evanston: {
      name: 'Evanston'
    },
    schaumburg: {
      name: 'Schaumburg'
    },
    bolingbrook: {
      name: 'Bolingbrook'
    },
    palatine: {
      name: 'Palatine'
    },
    skokie: {
      name: 'Skokie'
    },
    'des-plaines': {
      name: 'Des Plaines'
    },
    'orland-park': {
      name: 'Orland Park'
    },
    'tinley-park': {
      name: 'Tinley Park'
    },
    'oak-lawn': {
      name: 'Oak Lawn'
    },
    berwyn: {
      name: 'Berwyn'
    },
    'mount-prospect': {
      name: 'Mount Prospect'
    },
    wheaton: {
      name: 'Wheaton'
    },
    normal: {
      name: 'Normal'
    },
    'hoffman-estates': {
      name: 'Hoffman Estates'
    },
    'oak-park': {
      name: 'Oak Park'
    },
    'downers-grove': {
      name: 'Downers Grove'
    },
    glenview: {
      name: 'Glenview'
    },
    belleville: {
      name: 'Belleville'
    },
    elmhurst: {
      name: 'Elmhurst'
    },
    dekalb: {
      name: 'DeKalb'
    },
    moline: {
      name: 'Moline'
    },
    lombard: {
      name: 'Lombard'
    },
    'buffalo-grove': {
      name: 'Buffalo Grove'
    },
    urbana: {
      name: 'Urbana'
    },
    bartlett: {
      name: 'Bartlett'
    },
    'crystal-lake': {
      name: 'Crystal Lake'
    },
    quincy: {
      name: 'Quincy'
    },
    streamwood: {
      name: 'Streamwood'
    },
    'carol-stream': {
      name: 'Carol Stream'
    },
    romeoville: {
      name: 'Romeoville'
    },
    plainfield: {
      name: 'Plainfield'
    },
    'rock-island': {
      name: 'Rock Island'
    },
    'hanover-park': {
      name: 'Hanover Park'
    },
    carpentersville: {
      name: 'Carpentersville'
    },
    wheeling: {
      name: 'Wheeling'
    },
    'park-ridge': {
      name: 'Park Ridge'
    }
  },
  {
    name: 'Texas',
    slug: 'texas',
    abbreviation: 'TX',
    houston: {
      name: 'Houston'
    },
    'san-antonio': {
      name: 'San Antonio'
    },
    dallas: {
      name: 'Dallas'
    },
    austin: {
      name: 'Austin'
    },
    'fort-worth': {
      name: 'Fort Worth'
    },
    'el-paso': {
      name: 'El Paso'
    },
    arlington: {
      name: 'Arlington'
    },
    'corpus-christi': {
      name: 'Corpus Christi'
    },
    plano: {
      name: 'Plano'
    },
    laredo: {
      name: 'Laredo'
    },
    lubbock: {
      name: 'Lubbock'
    },
    garland: {
      name: 'Garland'
    },
    irving: {
      name: 'Irving'
    },
    amarillo: {
      name: 'Amarillo'
    },
    'grand-prairie': {
      name: 'Grand Prairie'
    },
    brownsville: {
      name: 'Brownsville'
    },
    pasadena: {
      name: 'Pasadena'
    },
    mesquite: {
      name: 'Mesquite'
    },
    mckinney: {
      name: 'Mckinney'
    },
    mcallen: {
      name: 'Mcallen'
    },
    killeen: {
      name: 'Killeen'
    },
    waco: {
      name: 'Waco'
    },
    carrollton: {
      name: 'Carrollton'
    },
    beaumont: {
      name: 'Beaumont'
    },
    abilene: {
      name: 'Abilene'
    },
    frisco: {
      name: 'Frisco'
    },
    denton: {
      name: 'Denton'
    },
    midland: {
      name: 'Midland'
    },
    'wichita-falls': {
      name: 'Wichita Falls'
    },
    odessa: {
      name: 'Odessa'
    },
    'round-rock': {
      name: 'Round Rock'
    },
    richardson: {
      name: 'Richardson'
    },
    tyler: {
      name: 'Tyler'
    },
    lewisville: {
      name: 'Lewisville'
    },
    'college-station': {
      name: 'College Station'
    },
    'san-angelo': {
      name: 'San Angelo'
    },
    pearland: {
      name: 'Pearland'
    },
    allen: {
      name: 'Allen'
    },
    'league-city': {
      name: 'League City'
    },
    longview: {
      name: 'Longview'
    },
    'sugar-land': {
      name: 'Sugar Land'
    },
    edinburg: {
      name: 'Edinburg'
    },
    mission: {
      name: 'Mission'
    },
    bryan: {
      name: 'Bryan'
    },
    baytown: {
      name: 'Baytown'
    },
    pharr: {
      name: 'Pharr'
    },
    'missouri-city': {
      name: 'Missouri City'
    },
    temple: {
      name: 'Temple'
    },
    harlingen: {
      name: 'Harlingen'
    },
    'flower-mound': {
      name: 'Flower Mound'
    }
  },
  {
    name: 'Pennsylvania',
    slug: 'pennsylvania',
    abbreviation: 'PA',
    philadelphia: {
      name: 'Philadelphia'
    },
    pittsburgh: {
      name: 'Pittsburgh'
    },
    allentown: {
      name: 'Allentown'
    },
    erie: {
      name: 'Erie'
    },
    reading: {
      name: 'Reading'
    },
    scranton: {
      name: 'Scranton'
    },
    bethlehem: {
      name: 'Bethlehem'
    },
    lancaster: {
      name: 'Lancaster'
    },
    harrisburg: {
      name: 'Harrisburg'
    },
    altoona: {
      name: 'Altoona'
    },
    york: {
      name: 'York'
    },
    'state-college': {
      name: 'State College'
    },
    'wilkes-barre': {
      name: 'Wilkes-Barre'
    },
    norristown: {
      name: 'Norristown'
    },
    chester: {
      name: 'Chester'
    },
    'bethel-park': {
      name: 'Bethel Park'
    },
    williamsport: {
      name: 'Williamsport'
    },
    'municipality-of-monroeville': {
      name: 'Municipality of Monroeville'
    },
    plum: {
      name: 'Plum'
    },
    easton: {
      name: 'Easton'
    },
    lebanon: {
      name: 'Lebanon'
    },
    hazleton: {
      name: 'Hazleton'
    },
    'new-castle': {
      name: 'New Castle'
    },
    pottstown: {
      name: 'Pottstown'
    },
    johnstown: {
      name: 'Johnstown'
    },
    'west-mifflin': {
      name: 'West Mifflin'
    },
    chambersburg: {
      name: 'Chambersburg'
    },
    'municipality-of-murrysville': {
      name: 'Municipality of Murrysville'
    },
    baldwin: {
      name: 'Baldwin'
    },
    mckeesport: {
      name: 'Mckeesport'
    },
    carlisle: {
      name: 'Carlisle'
    },
    'west-chester': {
      name: 'West Chester'
    },
    phoenixville: {
      name: 'Phoenixville'
    },
    lansdale: {
      name: 'Lansdale'
    },
    hermitage: {
      name: 'Hermitage'
    },
    wilkinsburg: {
      name: 'Wilkinsburg'
    },
    hanover: {
      name: 'Hanover'
    },
    greensburg: {
      name: 'Greensburg'
    },
    bloomsburg: {
      name: 'Bloomsburg'
    },
    pottsville: {
      name: 'Pottsville'
    },
    dunmore: {
      name: 'Dunmore'
    },
    sharon: {
      name: 'Sharon'
    },
    indiana: {
      name: 'Indiana'
    },
    whitehall: {
      name: 'Whitehall'
    },
    butler: {
      name: 'Butler'
    },
    washington: {
      name: 'Washington'
    },
    'franklin-park': {
      name: 'Franklin Park'
    },
    ephrata: {
      name: 'Ephrata'
    },
    meadville: {
      name: 'Meadville'
    },
    kingston: {
      name: 'Kingston'
    }
  },
  {
    name: 'Arizona',
    slug: 'arizona',
    abbreviation: 'AZ',
    phoenix: {
      name: 'Phoenix'
    },
    tucson: {
      name: 'Tucson'
    },
    mesa: {
      name: 'Mesa'
    },
    chandler: {
      name: 'Chandler'
    },
    glendale: {
      name: 'Glendale'
    },
    scottsdale: {
      name: 'Scottsdale'
    },
    gilbert: {
      name: 'Gilbert'
    },
    tempe: {
      name: 'Tempe'
    },
    peoria: {
      name: 'Peoria'
    },
    surprise: {
      name: 'Surprise'
    },
    yuma: {
      name: 'Yuma'
    },
    avondale: {
      name: 'Avondale'
    },
    flagstaff: {
      name: 'Flagstaff'
    },
    goodyear: {
      name: 'Goodyear'
    },
    'lake-havasu-city': {
      name: 'Lake Havasu City'
    },
    buckeye: {
      name: 'Buckeye'
    },
    'casa-grande': {
      name: 'Casa Grande'
    },
    'sierra-vista': {
      name: 'Sierra Vista'
    },
    maricopa: {
      name: 'Maricopa'
    },
    'oro-valley': {
      name: 'Oro Valley'
    },
    prescott: {
      name: 'Prescott'
    },
    'bullhead-city': {
      name: 'Bullhead City'
    },
    'prescott-valley': {
      name: 'Prescott Valley'
    },
    'apache-junction': {
      name: 'Apache Junction'
    },
    marana: {
      name: 'Marana'
    },
    'el-mirage': {
      name: 'El Mirage'
    },
    kingman: {
      name: 'Kingman'
    },
    'queen-creek': {
      name: 'Queen Creek'
    },
    florence: {
      name: 'Florence'
    },
    'san-luis': {
      name: 'San Luis'
    },
    sahuarita: {
      name: 'Sahuarita'
    },
    'fountain-hills': {
      name: 'Fountain Hills'
    },
    nogales: {
      name: 'Nogales'
    },
    douglas: {
      name: 'Douglas'
    },
    eloy: {
      name: 'Eloy'
    },
    payson: {
      name: 'Payson'
    },
    somerton: {
      name: 'Somerton'
    },
    'paradise-valley': {
      name: 'Paradise Valley'
    },
    coolidge: {
      name: 'Coolidge'
    },
    cottonwood: {
      name: 'Cottonwood'
    },
    'camp-verde': {
      name: 'Camp Verde'
    },
    'chino-valley': {
      name: 'Chino Valley'
    },
    'show-low': {
      name: 'Show Low'
    },
    sedona: {
      name: 'Sedona'
    },
    winslow: {
      name: 'Winslow'
    },
    safford: {
      name: 'Safford'
    },
    globe: {
      name: 'Globe'
    },
    page: {
      name: 'Page'
    },
    tolleson: {
      name: 'Tolleson'
    },
    wickenburg: {
      name: 'Wickenburg'
    }
  },
  {
    name: 'Florida',
    slug: 'florida',
    abbreviation: 'FL',
    jacksonville: {
      name: 'Jacksonville'
    },
    miami: {
      name: 'Miami'
    },
    tampa: {
      name: 'Tampa'
    },
    'st.-petersburg': {
      name: 'St. Petersburg'
    },
    orlando: {
      name: 'Orlando'
    },
    hialeah: {
      name: 'Hialeah'
    },
    tallahassee: {
      name: 'Tallahassee'
    },
    'fort-lauderdale': {
      name: 'Fort Lauderdale'
    },
    'port-st.-lucie': {
      name: 'Port St. Lucie'
    },
    'pembroke-pines': {
      name: 'Pembroke Pines'
    },
    'cape-coral': {
      name: 'Cape Coral'
    },
    hollywood: {
      name: 'Hollywood'
    },
    gainesville: {
      name: 'Gainesville'
    },
    miramar: {
      name: 'Miramar'
    },
    'coral-springs': {
      name: 'Coral Springs'
    },
    clearwater: {
      name: 'Clearwater'
    },
    'miami-gardens': {
      name: 'Miami Gardens'
    },
    'palm-bay': {
      name: 'Palm Bay'
    },
    'west-palm-beach': {
      name: 'West Palm Beach'
    },
    'pompano-beach': {
      name: 'Pompano Beach'
    },
    lakeland: {
      name: 'Lakeland'
    },
    davie: {
      name: 'Davie'
    },
    'miami-beach': {
      name: 'Miami Beach'
    },
    deltona: {
      name: 'Deltona'
    },
    plantation: {
      name: 'Plantation'
    },
    sunrise: {
      name: 'Sunrise'
    },
    'boca-raton': {
      name: 'Boca Raton'
    },
    largo: {
      name: 'Largo'
    },
    melbourne: {
      name: 'Melbourne'
    },
    'palm-coast': {
      name: 'Palm Coast'
    },
    'deerfield-beach': {
      name: 'Deerfield Beach'
    },
    'boynton-beach': {
      name: 'Boynton Beach'
    },
    lauderhill: {
      name: 'Lauderhill'
    },
    weston: {
      name: 'Weston'
    },
    'fort-myers': {
      name: 'Fort Myers'
    },
    'daytona-beach': {
      name: 'Daytona Beach'
    },
    'delray-beach': {
      name: 'Delray Beach'
    },
    homestead: {
      name: 'Homestead'
    },
    tamarac: {
      name: 'Tamarac'
    },
    kissimmee: {
      name: 'Kissimmee'
    },
    'north-miami': {
      name: 'North Miami'
    },
    'north-port': {
      name: 'North Port'
    },
    wellington: {
      name: 'Wellington'
    },
    ocala: {
      name: 'Ocala'
    },
    'port-orange': {
      name: 'Port Orange'
    },
    jupiter: {
      name: 'Jupiter'
    },
    sanford: {
      name: 'Sanford'
    },
    margate: {
      name: 'Margate'
    },
    'coconut-creek': {
      name: 'Coconut Creek'
    },
    pensacola: {
      name: 'Pensacola'
    }
  },
  {
    name: 'Indiana',
    slug: 'indiana',
    abbreviation: 'IN',
    indianapolis: {
      name: 'Indianapolis'
    },
    'fort-wayne': {
      name: 'Fort Wayne'
    },
    evansville: {
      name: 'Evansville'
    },
    'south-bend': {
      name: 'South Bend'
    },
    hammond: {
      name: 'Hammond'
    },
    bloomington: {
      name: 'Bloomington'
    },
    gary: {
      name: 'Gary'
    },
    carmel: {
      name: 'Carmel'
    },
    fishers: {
      name: 'Fishers'
    },
    muncie: {
      name: 'Muncie'
    },
    lafayette: {
      name: 'Lafayette'
    },
    'terre-haute': {
      name: 'Terre Haute'
    },
    anderson: {
      name: 'Anderson'
    },
    noblesville: {
      name: 'Noblesville'
    },
    elkhart: {
      name: 'Elkhart'
    },
    greenwood: {
      name: 'Greenwood'
    },
    mishawaka: {
      name: 'Mishawaka'
    },
    lawrence: {
      name: 'Lawrence'
    },
    kokomo: {
      name: 'Kokomo'
    },
    jeffersonville: {
      name: 'Jeffersonville'
    },
    columbus: {
      name: 'Columbus'
    },
    portage: {
      name: 'Portage'
    },
    richmond: {
      name: 'Richmond'
    },
    'new-albany': {
      name: 'New Albany'
    },
    merrillville: {
      name: 'Merrillville'
    },
    valparaiso: {
      name: 'Valparaiso'
    },
    goshen: {
      name: 'Goshen'
    },
    'michigan-city': {
      name: 'Michigan City'
    },
    westfield: {
      name: 'Westfield'
    },
    marion: {
      name: 'Marion'
    },
    'east-chicago': {
      name: 'East Chicago'
    },
    'west-lafayette': {
      name: 'West Lafayette'
    },
    schererville: {
      name: 'Schererville'
    },
    hobart: {
      name: 'Hobart'
    },
    plainfield: {
      name: 'Plainfield'
    },
    'crown-point': {
      name: 'Crown Point'
    },
    highland: {
      name: 'Highland'
    },
    franklin: {
      name: 'Franklin'
    },
    munster: {
      name: 'Munster'
    },
    'la-porte': {
      name: 'La Porte'
    },
    clarksville: {
      name: 'Clarksville'
    },
    brownsburg: {
      name: 'Brownsburg'
    },
    greenfield: {
      name: 'Greenfield'
    },
    shelbyville: {
      name: 'Shelbyville'
    },
    vincennes: {
      name: 'Vincennes'
    },
    logansport: {
      name: 'Logansport'
    },
    'new-castle': {
      name: 'New Castle'
    },
    seymour: {
      name: 'Seymour'
    },
    huntington: {
      name: 'Huntington'
    },
    griffith: {
      name: 'Griffith'
    }
  },
  {
    name: 'Ohio',
    slug: 'ohio',
    abbreviation: 'OH',
    columbus: {
      name: 'Columbus'
    },
    cleveland: {
      name: 'Cleveland'
    },
    cincinnati: {
      name: 'Cincinnati'
    },
    toledo: {
      name: 'Toledo'
    },
    akron: {
      name: 'Akron'
    },
    dayton: {
      name: 'Dayton'
    },
    parma: {
      name: 'Parma'
    },
    canton: {
      name: 'Canton'
    },
    youngstown: {
      name: 'Youngstown'
    },
    lorain: {
      name: 'Lorain'
    },
    hamilton: {
      name: 'Hamilton'
    },
    springfield: {
      name: 'Springfield'
    },
    kettering: {
      name: 'Kettering'
    },
    elyria: {
      name: 'Elyria'
    },
    lakewood: {
      name: 'Lakewood'
    },
    'cuyahoga-falls': {
      name: 'Cuyahoga Falls'
    },
    euclid: {
      name: 'Euclid'
    },
    middletown: {
      name: 'Middletown'
    },
    mansfield: {
      name: 'Mansfield'
    },
    newark: {
      name: 'Newark'
    },
    mentor: {
      name: 'Mentor'
    },
    'cleveland-heights': {
      name: 'Cleveland Heights'
    },
    beavercreek: {
      name: 'Beavercreek'
    },
    strongsville: {
      name: 'Strongsville'
    },
    fairfield: {
      name: 'Fairfield'
    },
    dublin: {
      name: 'Dublin'
    },
    warren: {
      name: 'Warren'
    },
    findlay: {
      name: 'Findlay'
    },
    lancaster: {
      name: 'Lancaster'
    },
    lima: {
      name: 'Lima'
    },
    'huber-heights': {
      name: 'Huber Heights'
    },
    marion: {
      name: 'Marion'
    },
    westerville: {
      name: 'Westerville'
    },
    reynoldsburg: {
      name: 'Reynoldsburg'
    },
    'grove-city': {
      name: 'Grove City'
    },
    stow: {
      name: 'Stow'
    },
    delaware: {
      name: 'Delaware'
    },
    brunswick: {
      name: 'Brunswick'
    },
    'upper-arlington': {
      name: 'Upper Arlington'
    },
    gahanna: {
      name: 'Gahanna'
    },
    westlake: {
      name: 'Westlake'
    },
    'north-olmsted': {
      name: 'North Olmsted'
    },
    fairborn: {
      name: 'Fairborn'
    },
    massillon: {
      name: 'Massillon'
    },
    mason: {
      name: 'Mason'
    },
    'north-royalton': {
      name: 'North Royalton'
    },
    'bowling-green': {
      name: 'Bowling Green'
    },
    'north-ridgeville': {
      name: 'North Ridgeville'
    },
    kent: {
      name: 'Kent'
    },
    'garfield-heights': {
      name: 'Garfield Heights'
    }
  },
  {
    name: 'North Carolina',
    slug: 'north-carolina',
    abbreviation: 'NC',
    charlotte: {
      name: 'Charlotte'
    },
    raleigh: {
      name: 'Raleigh'
    },
    greensboro: {
      name: 'Greensboro'
    },
    'winston-salem': {
      name: 'Winston-Salem'
    },
    durham: {
      name: 'Durham'
    },
    fayetteville: {
      name: 'Fayetteville'
    },
    cary: {
      name: 'Cary'
    },
    wilmington: {
      name: 'Wilmington'
    },
    'high-point': {
      name: 'High Point'
    },
    greenville: {
      name: 'Greenville'
    },
    asheville: {
      name: 'Asheville'
    },
    concord: {
      name: 'Concord'
    },
    gastonia: {
      name: 'Gastonia'
    },
    jacksonville: {
      name: 'Jacksonville'
    },
    'rocky-mount': {
      name: 'Rocky Mount'
    },
    'chapel-hill': {
      name: 'Chapel Hill'
    },
    burlington: {
      name: 'Burlington'
    },
    wilson: {
      name: 'Wilson'
    },
    huntersville: {
      name: 'Huntersville'
    },
    kannapolis: {
      name: 'Kannapolis'
    },
    hickory: {
      name: 'Hickory'
    },
    apex: {
      name: 'Apex'
    },
    goldsboro: {
      name: 'Goldsboro'
    },
    salisbury: {
      name: 'Salisbury'
    },
    'indian-trail': {
      name: 'Indian Trail'
    },
    monroe: {
      name: 'Monroe'
    },
    mooresville: {
      name: 'Mooresville'
    },
    'wake-forest': {
      name: 'Wake Forest'
    },
    'new-bern': {
      name: 'New Bern'
    },
    sanford: {
      name: 'Sanford'
    },
    matthews: {
      name: 'Matthews'
    },
    thomasville: {
      name: 'Thomasville'
    },
    garner: {
      name: 'Garner'
    },
    asheboro: {
      name: 'Asheboro'
    },
    cornelius: {
      name: 'Cornelius'
    },
    'holly-springs': {
      name: 'Holly Springs'
    },
    statesville: {
      name: 'Statesville'
    },
    kernersville: {
      name: 'Kernersville'
    },
    'mint-hill': {
      name: 'Mint Hill'
    },
    kinston: {
      name: 'Kinston'
    },
    lumberton: {
      name: 'Lumberton'
    },
    havelock: {
      name: 'Havelock'
    },
    shelby: {
      name: 'Shelby'
    },
    carrboro: {
      name: 'Carrboro'
    },
    lexington: {
      name: 'Lexington'
    },
    'elizabeth-city': {
      name: 'Elizabeth City'
    },
    clemmons: {
      name: 'Clemmons'
    },
    morrisville: {
      name: 'Morrisville'
    },
    lenoir: {
      name: 'Lenoir'
    },
    'fuquay-varina': {
      name: 'Fuquay-Varina'
    }
  },
  {
    name: 'Michigan',
    slug: 'michigan',
    abbreviation: 'MI',
    detroit: {
      name: 'Detroit'
    },
    'grand-rapids': {
      name: 'Grand Rapids'
    },
    warren: {
      name: 'Warren'
    },
    'sterling-heights': {
      name: 'Sterling Heights'
    },
    lansing: {
      name: 'Lansing'
    },
    'ann-arbor': {
      name: 'Ann Arbor'
    },
    flint: {
      name: 'Flint'
    },
    dearborn: {
      name: 'Dearborn'
    },
    livonia: {
      name: 'Livonia'
    },
    westland: {
      name: 'Westland'
    },
    troy: {
      name: 'Troy'
    },
    'farmington-hills': {
      name: 'Farmington Hills'
    },
    kalamazoo: {
      name: 'Kalamazoo'
    },
    wyoming: {
      name: 'Wyoming'
    },
    southfield: {
      name: 'Southfield'
    },
    'rochester-hills': {
      name: 'Rochester Hills'
    },
    taylor: {
      name: 'Taylor'
    },
    'st.-clair-shores': {
      name: 'St. Clair Shores'
    },
    pontiac: {
      name: 'Pontiac'
    },
    'dearborn-heights': {
      name: 'Dearborn Heights'
    },
    'royal-oak': {
      name: 'Royal Oak'
    },
    novi: {
      name: 'Novi'
    },
    'battle-creek': {
      name: 'Battle Creek'
    },
    saginaw: {
      name: 'Saginaw'
    },
    kentwood: {
      name: 'Kentwood'
    },
    'east-lansing': {
      name: 'East Lansing'
    },
    roseville: {
      name: 'Roseville'
    },
    portage: {
      name: 'Portage'
    },
    midland: {
      name: 'Midland'
    },
    muskegon: {
      name: 'Muskegon'
    },
    'lincoln-park': {
      name: 'Lincoln Park'
    },
    'bay-city': {
      name: 'Bay City'
    },
    jackson: {
      name: 'Jackson'
    },
    holland: {
      name: 'Holland'
    },
    eastpointe: {
      name: 'Eastpointe'
    },
    'port-huron': {
      name: 'Port Huron'
    },
    southgate: {
      name: 'Southgate'
    },
    burton: {
      name: 'Burton'
    },
    'madison-heights': {
      name: 'Madison Heights'
    },
    'oak-park': {
      name: 'Oak Park'
    },
    'allen-park': {
      name: 'Allen Park'
    },
    'garden-city': {
      name: 'Garden City'
    },
    'mount-pleasant': {
      name: 'Mount Pleasant'
    },
    wyandotte: {
      name: 'Wyandotte'
    },
    inkster: {
      name: 'Inkster'
    },
    'norton-shores': {
      name: 'Norton Shores'
    },
    romulus: {
      name: 'Romulus'
    },
    walker: {
      name: 'Walker'
    },
    hamtramck: {
      name: 'Hamtramck'
    },
    'auburn-hills': {
      name: 'Auburn Hills'
    }
  },
  {
    name: 'Tennessee',
    slug: 'tennessee',
    abbreviation: 'TN',
    memphis: {
      name: 'Memphis'
    },
    nashville: {
      name: 'Nashville'
    },
    knoxville: {
      name: 'Knoxville'
    },
    chattanooga: {
      name: 'Chattanooga'
    },
    clarksville: {
      name: 'Clarksville'
    },
    murfreesboro: {
      name: 'Murfreesboro'
    },
    jackson: {
      name: 'Jackson'
    },
    'johnson-city': {
      name: 'Johnson City'
    },
    franklin: {
      name: 'Franklin'
    },
    bartlett: {
      name: 'Bartlett'
    },
    hendersonville: {
      name: 'Hendersonville'
    },
    kingsport: {
      name: 'Kingsport'
    },
    collierville: {
      name: 'Collierville'
    },
    cleveland: {
      name: 'Cleveland'
    },
    smyrna: {
      name: 'Smyrna'
    },
    germantown: {
      name: 'Germantown'
    },
    brentwood: {
      name: 'Brentwood'
    },
    columbia: {
      name: 'Columbia'
    },
    'la-vergne': {
      name: 'La Vergne'
    },
    cookeville: {
      name: 'Cookeville'
    },
    gallatin: {
      name: 'Gallatin'
    },
    'oak-ridge': {
      name: 'Oak Ridge'
    },
    morristown: {
      name: 'Morristown'
    },
    'spring-hill': {
      name: 'Spring Hill'
    },
    maryville: {
      name: 'Maryville'
    },
    bristol: {
      name: 'Bristol'
    },
    lebanon: {
      name: 'Lebanon'
    },
    'mount-juliet': {
      name: 'Mount Juliet'
    },
    'east-ridge': {
      name: 'East Ridge'
    },
    farragut: {
      name: 'Farragut'
    },
    shelbyville: {
      name: 'Shelbyville'
    },
    tullahoma: {
      name: 'Tullahoma'
    },
    dyersburg: {
      name: 'Dyersburg'
    },
    springfield: {
      name: 'Springfield'
    },
    goodlettsville: {
      name: 'Goodlettsville'
    },
    greeneville: {
      name: 'Greeneville'
    },
    sevierville: {
      name: 'Sevierville'
    },
    dickson: {
      name: 'Dickson'
    },
    elizabethton: {
      name: 'Elizabethton'
    },
    mcminnville: {
      name: 'Mcminnville'
    },
    athens: {
      name: 'Athens'
    },
    'soddy-daisy': {
      name: 'Soddy-Daisy'
    },
    lakeland: {
      name: 'Lakeland'
    },
    'red-bank': {
      name: 'Red Bank'
    },
    arlington: {
      name: 'Arlington'
    },
    portland: {
      name: 'Portland'
    },
    martin: {
      name: 'Martin'
    },
    lewisburg: {
      name: 'Lewisburg'
    },
    'union-city': {
      name: 'Union City'
    },
    crossville: {
      name: 'Crossville'
    }
  },
  {
    name: 'Maryland',
    slug: 'maryland',
    abbreviation: 'MD',
    baltimore: {
      name: 'Baltimore'
    },
    frederick: {
      name: 'Frederick'
    },
    rockville: {
      name: 'Rockville'
    },
    gaithersburg: {
      name: 'Gaithersburg'
    },
    bowie: {
      name: 'Bowie'
    },
    hagerstown: {
      name: 'Hagerstown'
    },
    annapolis: {
      name: 'Annapolis'
    },
    'college-park': {
      name: 'College Park'
    },
    salisbury: {
      name: 'Salisbury'
    },
    laurel: {
      name: 'Laurel'
    },
    greenbelt: {
      name: 'Greenbelt'
    },
    cumberland: {
      name: 'Cumberland'
    },
    westminister: {
      name: 'Westminister'
    },
    hyattsville: {
      name: 'Hyattsville'
    },
    'takoma-park': {
      name: 'Takoma Park'
    },
    easton: {
      name: 'Easton'
    },
    elkton: {
      name: 'Elkton'
    },
    aberdeen: {
      name: 'Aberdeen'
    },
    'havre-de-grace': {
      name: 'Havre De Grace'
    },
    cambridge: {
      name: 'Cambridge'
    },
    'new-carrollton': {
      name: 'New Carrollton'
    },
    'bel-air': {
      name: 'Bel Air'
    },
    'mount-airy': {
      name: 'Mount Airy'
    },
    bladensburg: {
      name: 'Bladensburg'
    },
    frostberg: {
      name: 'Frostberg'
    },
    'la-plata': {
      name: 'La Plata'
    },
    'mount-rainier': {
      name: 'Mount Rainier'
    },
    'ocean-city': {
      name: 'Ocean City'
    },
    'riverdale-park': {
      name: 'Riverdale Park'
    },
    taneytown: {
      name: 'Taneytown'
    },
    hampstead: {
      name: 'Hampstead'
    },
    cheverly: {
      name: 'Cheverly'
    },
    thurmont: {
      name: 'Thurmont'
    },
    glenarden: {
      name: 'Glenarden'
    },
    brunswick: {
      name: 'Brunswick'
    },
    'district-heights': {
      name: 'District Heights'
    },
    walkersville: {
      name: 'Walkersville'
    },
    'chesapeake-beach': {
      name: 'Chesapeake Beach'
    },
    chestertown: {
      name: 'Chestertown'
    },
    poolesville: {
      name: 'Poolesville'
    },
    fruitland: {
      name: 'Fruitland'
    },
    manchester: {
      name: 'Manchester'
    },
    'seat-pleasant': {
      name: 'Seat Pleasant'
    },
    berlin: {
      name: 'Berlin'
    },
    sykesville: {
      name: 'Sykesville'
    },
    denton: {
      name: 'Denton'
    },
    perryville: {
      name: 'Perryville'
    },
    'capitol-heights': {
      name: 'Capitol Heights'
    },
    centreville: {
      name: 'Centreville'
    },
    'pocomoke-city': {
      name: 'Pocomoke City'
    }
  },
  {
    name: 'Massachusetts',
    slug: 'massachusetts',
    abbreviation: 'MA',
    boston: {
      name: 'Boston'
    },
    worcester: {
      name: 'Worcester'
    },
    springfield: {
      name: 'Springfield'
    },
    lowell: {
      name: 'Lowell'
    },
    cambridge: {
      name: 'Cambridge'
    },
    'new-bedford': {
      name: 'New Bedford'
    },
    brockton: {
      name: 'Brockton'
    },
    quincy: {
      name: 'Quincy'
    },
    lynn: {
      name: 'Lynn'
    },
    'fall-river': {
      name: 'Fall River'
    },
    newton: {
      name: 'Newton'
    },
    lawrence: {
      name: 'Lawrence'
    },
    somerville: {
      name: 'Somerville'
    },
    haverhill: {
      name: 'Haverhill'
    },
    waltham: {
      name: 'Waltham'
    },
    malden: {
      name: 'Malden'
    },
    medford: {
      name: 'Medford'
    },
    taunton: {
      name: 'Taunton'
    },
    chicopee: {
      name: 'Chicopee'
    },
    weymouth: {
      name: 'Weymouth'
    },
    revere: {
      name: 'Revere'
    },
    peabody: {
      name: 'Peabody'
    },
    methuen: {
      name: 'Methuen'
    },
    barnstable: {
      name: 'Barnstable'
    },
    pittsfield: {
      name: 'Pittsfield'
    },
    attleboro: {
      name: 'Attleboro'
    },
    everett: {
      name: 'Everett'
    },
    salem: {
      name: 'Salem'
    },
    westfield: {
      name: 'Westfield'
    },
    leominster: {
      name: 'Leominster'
    },
    fitchburg: {
      name: 'Fitchburg'
    },
    holyoke: {
      name: 'Holyoke'
    },
    beverly: {
      name: 'Beverly'
    },
    marlborough: {
      name: 'Marlborough'
    },
    woburn: {
      name: 'Woburn'
    },
    braintree: {
      name: 'Braintree'
    },
    chelsea: {
      name: 'Chelsea'
    },
    randolph: {
      name: 'Randolph'
    },
    watertown: {
      name: 'Watertown'
    },
    franklin: {
      name: 'Franklin'
    },
    gloucester: {
      name: 'Gloucester'
    },
    northampton: {
      name: 'Northampton'
    },
    agawam: {
      name: 'Agawam'
    },
    'west-springfield': {
      name: 'West Springfield'
    },
    melrose: {
      name: 'Melrose'
    },
    gardner: {
      name: 'Gardner'
    },
    winthrop: {
      name: 'Winthrop'
    },
    greenfield: {
      name: 'Greenfield'
    },
    newburyport: {
      name: 'Newburyport'
    },
    southbridge: {
      name: 'Southbridge'
    }
  },
  {
    name: 'Washington',
    slug: 'washington',
    abbreviation: 'WA',
    seattle: {
      name: 'Seattle'
    },
    spokane: {
      name: 'Spokane'
    },
    tacoma: {
      name: 'Tacoma'
    },
    vancouver: {
      name: 'Vancouver'
    },
    bellevue: {
      name: 'Bellevue'
    },
    everett: {
      name: 'Everett'
    },
    kent: {
      name: 'Kent'
    },
    yakima: {
      name: 'Yakima'
    },
    renton: {
      name: 'Renton'
    },
    'spokane-valley': {
      name: 'Spokane Valley'
    },
    'federal-way': {
      name: 'Federal Way'
    },
    bellingham: {
      name: 'Bellingham'
    },
    kennewick: {
      name: 'Kennewick'
    },
    auburn: {
      name: 'Auburn'
    },
    marysville: {
      name: 'Marysville'
    },
    pasco: {
      name: 'Pasco'
    },
    lakewood: {
      name: 'Lakewood'
    },
    redmond: {
      name: 'Redmond'
    },
    shoreline: {
      name: 'Shoreline'
    },
    kirkland: {
      name: 'Kirkland'
    },
    richland: {
      name: 'Richland'
    },
    olympia: {
      name: 'Olympia'
    },
    sammamish: {
      name: 'Sammamish'
    },
    lacey: {
      name: 'Lacey'
    },
    edmonds: {
      name: 'Edmonds'
    },
    bremerton: {
      name: 'Bremerton'
    },
    puyallup: {
      name: 'Puyallup'
    },
    longview: {
      name: 'Longview'
    },
    lynnwood: {
      name: 'Lynnwood'
    },
    bothell: {
      name: 'Bothell'
    },
    burien: {
      name: 'Burien'
    },
    wenatchee: {
      name: 'Wenatchee'
    },
    'mount-vernon': {
      name: 'Mount Vernon'
    },
    'walla-walla': {
      name: 'Walla Walla'
    },
    'university-place': {
      name: 'University Place'
    },
    issaquah: {
      name: 'Issaquah'
    },
    pullman: {
      name: 'Pullman'
    },
    'des-moines': {
      name: 'Des Moines'
    },
    'lake-stevens': {
      name: 'Lake Stevens'
    },
    seatac: {
      name: 'Seatac'
    },
    'bainbridge-island': {
      name: 'Bainbridge Island'
    },
    'mercer-island': {
      name: 'Mercer Island'
    },
    'maple-valley': {
      name: 'Maple Valley'
    },
    'oak-harbor': {
      name: 'Oak Harbor'
    },
    kenmore: {
      name: 'Kenmore'
    },
    'moses-lake': {
      name: 'Moses Lake'
    },
    mukilteo: {
      name: 'Mukilteo'
    },
    'mountlake-terrace': {
      name: 'Mountlake Terrace'
    },
    camas: {
      name: 'Camas'
    },
    tukwila: {
      name: 'Tukwila'
    }
  },
  {
    name: 'District of Columbia',
    slug: 'washington-dc',
    abbreviation: 'DC',
    washington: {
      name: 'Washington'
    },
    alexandria: {
      name: 'Alexandria'
    },
    georgetown: {
      name: 'Georgetown'
    },
    ardmore: {
      name: 'Ardmore'
    },
    chickasha: {
      name: 'Chickasha'
    },
    coalgate: {
      name: 'Coalgate'
    },
    durant: {
      name: 'Durant'
    },
    muscogee: {
      name: 'Muscogee'
    },
    'south-mcalester': {
      name: 'South Mcalester'
    }
  },
  {
    name: 'Colorado',
    slug: 'colorado',
    abbreviation: 'CO',
    aspen: {
      name: 'Aspen'
    },
    denver: {
      name: 'Denver'
    },
    'colorado-springs': {
      name: 'Colorado Springs'
    },
    aurora: {
      name: 'Aurora'
    },
    'fort-collins': {
      name: 'Fort Collins'
    },
    lakewood: {
      name: 'Lakewood'
    },
    thornton: {
      name: 'Thornton'
    },
    pueblo: {
      name: 'Pueblo'
    },
    arvada: {
      name: 'Arvada'
    },
    westminster: {
      name: 'Westminster'
    },
    centennial: {
      name: 'Centennial'
    },
    boulder: {
      name: 'Boulder'
    },
    greeley: {
      name: 'Greeley'
    },
    longmont: {
      name: 'Longmont'
    },
    loveland: {
      name: 'Loveland'
    },
    'grand-junction': {
      name: 'Grand Junction'
    },
    broomfield: {
      name: 'Broomfield'
    },
    'castle-rock': {
      name: 'Castle Rock'
    },
    'commerce-city': {
      name: 'Commerce City'
    },
    parker: {
      name: 'Parker'
    },
    littleton: {
      name: 'Littleton'
    },
    northglenn: {
      name: 'Northglenn'
    },
    brighton: {
      name: 'Brighton'
    },
    englewood: {
      name: 'Englewood'
    },
    'wheat-ridge': {
      name: 'Wheat Ridge'
    },
    fountain: {
      name: 'Fountain'
    },
    lafayette: {
      name: 'Lafayette'
    },
    montrose: {
      name: 'Montrose'
    },
    golden: {
      name: 'Golden'
    },
    windsor: {
      name: 'Windsor'
    },
    evans: {
      name: 'Evans'
    },
    louisville: {
      name: 'Louisville'
    },
    erie: {
      name: 'Erie'
    },
    durango: {
      name: 'Durango'
    },
    'canon-city': {
      name: 'Canon City'
    },
    sterling: {
      name: 'Sterling'
    },
    'greenwood-village': {
      name: 'Greenwood Village'
    },
    fruita: {
      name: 'Fruita'
    },
    superior: {
      name: 'Superior'
    },
    'steamboat-springs': {
      name: 'Steamboat Springs'
    },
    'federal-heights': {
      name: 'Federal Heights'
    },
    'fort-morgan': {
      name: 'Fort Morgan'
    },
    'castle-pines-north': {
      name: 'Castle Pines North'
    },
    'lone-tree': {
      name: 'Lone Tree'
    },
    firestone: {
      name: 'Firestone'
    },
    johnstown: {
      name: 'Johnstown'
    },
    'glenwood-springs': {
      name: 'Glenwood Springs'
    },
    craig: {
      name: 'Craig'
    },
    rifle: {
      name: 'Rifle'
    },
    trinidad: {
      name: 'Trinidad'
    },
    delta: {
      name: 'Delta'
    }
  },
  {
    name: 'Kentucky',
    slug: 'kentucky',
    abbreviation: 'KY',
    louisville: {
      name: 'Louisville'
    },
    lexington: {
      name: 'Lexington'
    },
    'bowling-green': {
      name: 'Bowling Green'
    },
    owensboro: {
      name: 'Owensboro'
    },
    covington: {
      name: 'Covington'
    },
    hopkinsville: {
      name: 'Hopkinsville'
    },
    richmond: {
      name: 'Richmond'
    },
    florence: {
      name: 'Florence'
    },
    georgetown: {
      name: 'Georgetown'
    },
    henderson: {
      name: 'Henderson'
    },
    elizabethtown: {
      name: 'Elizabethtown'
    },
    nicholasville: {
      name: 'Nicholasville'
    },
    jeffersontown: {
      name: 'Jeffersontown'
    },
    frankfort: {
      name: 'Frankfort'
    },
    paducah: {
      name: 'Paducah'
    },
    independence: {
      name: 'Independence'
    },
    radcliff: {
      name: 'Radcliff'
    },
    ashland: {
      name: 'Ashland'
    },
    madisonville: {
      name: 'Madisonville'
    },
    winchester: {
      name: 'Winchester'
    },
    erlanger: {
      name: 'Erlanger'
    },
    murray: {
      name: 'Murray'
    },
    'st.-matthews': {
      name: 'St. Matthews'
    },
    'fort-thomas': {
      name: 'Fort Thomas'
    },
    danville: {
      name: 'Danville'
    },
    newport: {
      name: 'Newport'
    },
    shively: {
      name: 'Shively'
    },
    shelbyville: {
      name: 'Shelbyville'
    },
    glasgow: {
      name: 'Glasgow'
    },
    berea: {
      name: 'Berea'
    },
    bardstown: {
      name: 'Bardstown'
    },
    shepherdsville: {
      name: 'Shepherdsville'
    },
    somerset: {
      name: 'Somerset'
    },
    lyndon: {
      name: 'Lyndon'
    },
    lawrenceburg: {
      name: 'Lawrenceburg'
    },
    middlesborough: {
      name: 'Middlesborough'
    },
    mayfield: {
      name: 'Mayfield'
    },
    'mount-washington': {
      name: 'Mount Washington'
    },
    campbellsville: {
      name: 'Campbellsville'
    },
    maysville: {
      name: 'Maysville'
    },
    edgewood: {
      name: 'Edgewood'
    },
    versailles: {
      name: 'Versailles'
    },
    paris: {
      name: 'Paris'
    },
    alexandria: {
      name: 'Alexandria'
    },
    elsmere: {
      name: 'Elsmere'
    },
    franklin: {
      name: 'Franklin'
    },
    harrodsburg: {
      name: 'Harrodsburg'
    },
    'fort-mitchell': {
      name: 'Fort Mitchell'
    },
    hillview: {
      name: 'Hillview'
    },
    'la-grange': {
      name: 'La Grange'
    }
  },
  {
    name: 'Wisconsin',
    slug: 'wisconsin',
    abbreviation: 'WI',
    milwaukee: {
      name: 'Milwaukee'
    },
    madison: {
      name: 'Madison'
    },
    'green-bay': {
      name: 'Green Bay'
    },
    kenosha: {
      name: 'Kenosha'
    },
    racine: {
      name: 'Racine'
    },
    appleton: {
      name: 'Appleton'
    },
    waukesha: {
      name: 'Waukesha'
    },
    oshkosh: {
      name: 'Oshkosh'
    },
    'eau-claire': {
      name: 'Eau Claire'
    },
    janesville: {
      name: 'Janesville'
    },
    'west-allis': {
      name: 'West Allis'
    },
    'la-crosse': {
      name: 'La Crosse'
    },
    sheboygan: {
      name: 'Sheboygan'
    },
    wauwatosa: {
      name: 'Wauwatosa'
    },
    'fond-du-lac': {
      name: 'Fond Du Lac'
    },
    'new-berlin': {
      name: 'New Berlin'
    },
    wausau: {
      name: 'Wausau'
    },
    brookfield: {
      name: 'Brookfield'
    },
    beloit: {
      name: 'Beloit'
    },
    greenfield: {
      name: 'Greenfield'
    },
    'menomonee-falls': {
      name: 'Menomonee Falls'
    },
    franklin: {
      name: 'Franklin'
    },
    'oak-creek': {
      name: 'Oak Creek'
    },
    manitowoc: {
      name: 'Manitowoc'
    },
    'west-bend': {
      name: 'West Bend'
    },
    'sun-prairie': {
      name: 'Sun Prairie'
    },
    superior: {
      name: 'Superior'
    },
    'stevens-point': {
      name: 'Stevens Point'
    },
    'mount-pleasant': {
      name: 'Mount Pleasant'
    },
    neenah: {
      name: 'Neenah'
    },
    fitchburg: {
      name: 'Fitchburg'
    },
    caledonia: {
      name: 'Caledonia'
    },
    muskego: {
      name: 'Muskego'
    },
    watertown: {
      name: 'Watertown'
    },
    'de-pere': {
      name: 'De Pere'
    },
    mequon: {
      name: 'Mequon'
    },
    'south-milwaukee': {
      name: 'South Milwaukee'
    },
    germantown: {
      name: 'Germantown'
    },
    'pleasant-prairie': {
      name: 'Pleasant Prairie'
    },
    marshfield: {
      name: 'Marshfield'
    },
    'wisconson-rapids': {
      name: 'Wisconson Rapids'
    },
    cudahy: {
      name: 'Cudahy'
    },
    onalaska: {
      name: 'Onalaska'
    },
    middleton: {
      name: 'Middleton'
    },
    howard: {
      name: 'Howard'
    },
    menasha: {
      name: 'Menasha'
    },
    ashwaubenon: {
      name: 'Ashwaubenon'
    },
    menomonie: {
      name: 'Menomonie'
    },
    'beaver-dam': {
      name: 'Beaver Dam'
    },
    oconomowoc: {
      name: 'Oconomowoc'
    }
  },
  {
    name: 'Oregon',
    slug: 'oregon',
    abbreviation: 'OR',
    portland: {
      name: 'Portland'
    },
    eugene: {
      name: 'Eugene'
    },
    salem: {
      name: 'Salem'
    },
    gresham: {
      name: 'Gresham'
    },
    hillsboro: {
      name: 'Hillsboro'
    },
    beaverton: {
      name: 'Beaverton'
    },
    bend: {
      name: 'Bend'
    },
    medford: {
      name: 'Medford'
    },
    springfield: {
      name: 'Springfield'
    },
    corvallis: {
      name: 'Corvallis'
    },
    albany: {
      name: 'Albany'
    },
    tigard: {
      name: 'Tigard'
    },
    'lake-oswego': {
      name: 'Lake Oswego'
    },
    keizer: {
      name: 'Keizer'
    },
    'grants-pass': {
      name: 'Grants Pass'
    },
    mcminnville: {
      name: 'Mcminnville'
    },
    'oregon-city': {
      name: 'Oregon City'
    },
    redmond: {
      name: 'Redmond'
    },
    tualatin: {
      name: 'Tualatin'
    },
    'west-linn': {
      name: 'West Linn'
    },
    woodburn: {
      name: 'Woodburn'
    },
    newberg: {
      name: 'Newberg'
    },
    roseburg: {
      name: 'Roseburg'
    },
    'forest-grove': {
      name: 'Forest Grove'
    },
    'klamath-falls': {
      name: 'Klamath Falls'
    },
    milwaukie: {
      name: 'Milwaukie'
    },
    ashland: {
      name: 'Ashland'
    },
    wilsonville: {
      name: 'Wilsonville'
    },
    sherwood: {
      name: 'Sherwood'
    },
    'central-point': {
      name: 'Central Point'
    },
    hermiston: {
      name: 'Hermiston'
    },
    pendleton: {
      name: 'Pendleton'
    },
    'coos-bay': {
      name: 'Coos Bay'
    },
    troutdale: {
      name: 'Troutdale'
    },
    canby: {
      name: 'Canby'
    },
    lebanon: {
      name: 'Lebanon'
    },
    dallas: {
      name: 'Dallas'
    },
    'happy-valley': {
      name: 'Happy Valley'
    },
    'the-dalles': {
      name: 'The Dalles'
    },
    'la-grande': {
      name: 'La Grande'
    },
    'st.-helens': {
      name: 'St. Helens'
    },
    cornelius: {
      name: 'Cornelius'
    },
    gladstone: {
      name: 'Gladstone'
    },
    ontario: {
      name: 'Ontario'
    },
    damascus: {
      name: 'Damascus'
    },
    newport: {
      name: 'Newport'
    },
    'baker-city': {
      name: 'Baker City'
    },
    'north-bend': {
      name: 'North Bend'
    },
    'cottage-grove': {
      name: 'Cottage Grove'
    },
    sandy: {
      name: 'Sandy'
    }
  },
  {
    name: 'Nevada',
    slug: 'nevada',
    abbreviation: 'NV',
    'las-vegas': {
      name: 'Las Vegas'
    },
    henderson: {
      name: 'Henderson'
    },
    reno: {
      name: 'Reno'
    },
    'north-las-vegas': {
      name: 'North Las Vegas'
    },
    sparks: {
      name: 'Sparks'
    },
    'carson-city': {
      name: 'Carson City'
    },
    fernley: {
      name: 'Fernley'
    },
    elko: {
      name: 'Elko'
    },
    mesquite: {
      name: 'Mesquite'
    },
    'boulder-city': {
      name: 'Boulder City'
    },
    fallon: {
      name: 'Fallon'
    },
    winnemucca: {
      name: 'Winnemucca'
    },
    'west-wendover': {
      name: 'West Wendover'
    },
    ely: {
      name: 'Ely'
    },
    yerington: {
      name: 'Yerington'
    },
    eureka: {
      name: 'Eureka'
    },
    'virginia-city': {
      name: 'Virginia City'
    },
    enterprise: {
      name: 'Enterprise'
    },
    'gardnerville-ranchos': {
      name: 'Gardnerville Ranchos'
    },
    pahrump: {
      name: 'Pahrump'
    },
    paradise: {
      name: 'Paradise'
    },
    'spring-creek': {
      name: 'Spring Creek'
    },
    'spring-valley': {
      name: 'Spring Valley'
    },
    'sun-valley': {
      name: 'Sun Valley'
    },
    'sunrise-manor': {
      name: 'Sunrise Manor'
    },
    winchester: {
      name: 'Winchester'
    }
  },
  {
    name: 'Oklahoma',
    slug: 'oklahoma',
    abbreviation: 'OK',
    'oklahoma-city': {
      name: 'Oklahoma City'
    },
    tulsa: {
      name: 'Tulsa'
    },
    norman: {
      name: 'Norman'
    },
    'broken-arrow': {
      name: 'Broken Arrow'
    },
    lawton: {
      name: 'Lawton'
    },
    edmond: {
      name: 'Edmond'
    },
    moore: {
      name: 'Moore'
    },
    'midwest-city': {
      name: 'Midwest City'
    },
    enid: {
      name: 'Enid'
    },
    stillwater: {
      name: 'Stillwater'
    },
    muskogee: {
      name: 'Muskogee'
    },
    bartlesville: {
      name: 'Bartlesville'
    },
    shawnee: {
      name: 'Shawnee'
    },
    owasso: {
      name: 'Owasso'
    },
    'ponca-city': {
      name: 'Ponca City'
    },
    ardmore: {
      name: 'Ardmore'
    },
    duncan: {
      name: 'Duncan'
    },
    yukon: {
      name: 'Yukon'
    },
    'del-city': {
      name: 'Del City'
    },
    bixby: {
      name: 'Bixby'
    },
    sapulpa: {
      name: 'Sapulpa'
    },
    altus: {
      name: 'Altus'
    },
    bethany: {
      name: 'Bethany'
    },
    'sand-springs': {
      name: 'Sand Springs'
    },
    claremore: {
      name: 'Claremore'
    },
    mcalester: {
      name: 'Mcalester'
    },
    mustang: {
      name: 'Mustang'
    },
    jenks: {
      name: 'Jenks'
    },
    ada: {
      name: 'Ada'
    },
    'el-reno': {
      name: 'El Reno'
    },
    chickasha: {
      name: 'Chickasha'
    },
    durant: {
      name: 'Durant'
    },
    tahlequah: {
      name: 'Tahlequah'
    },
    miami: {
      name: 'Miami'
    },
    okmulgee: {
      name: 'Okmulgee'
    },
    woodward: {
      name: 'Woodward'
    },
    'elk-city': {
      name: 'Elk City'
    },
    guymon: {
      name: 'Guymon'
    },
    choctaw: {
      name: 'Choctaw'
    },
    weatherford: {
      name: 'Weatherford'
    },
    glenpool: {
      name: 'Glenpool'
    },
    guthrie: {
      name: 'Guthrie'
    },
    'warr-acres': {
      name: 'Warr Acres'
    },
    coweta: {
      name: 'Coweta'
    },
    'pryor-creek': {
      name: 'Pryor Creek'
    },
    clinton: {
      name: 'Clinton'
    },
    'the-village': {
      name: 'The Village'
    },
    sallisaw: {
      name: 'Sallisaw'
    },
    poteau: {
      name: 'Poteau'
    },
    wagoner: {
      name: 'Wagoner'
    }
  },
  {
    name: 'New Mexico',
    slug: 'new-mexico',
    abbreviation: 'NM',
    albuquerque: {
      name: 'Albuquerque'
    },
    'las-cruces': {
      name: 'Las Cruces'
    },
    'rio-rancho': {
      name: 'Rio Rancho'
    },
    'santa-fe': {
      name: 'Santa Fe'
    },
    roswell: {
      name: 'Roswell'
    },
    farmington: {
      name: 'Farmington'
    },
    clovis: {
      name: 'Clovis'
    },
    hobbs: {
      name: 'Hobbs'
    },
    alamogordo: {
      name: 'Alamogordo'
    },
    carlsbad: {
      name: 'Carlsbad'
    },
    gallup: {
      name: 'Gallup'
    },
    deming: {
      name: 'Deming'
    },
    'los-lunas': {
      name: 'Los Lunas'
    },
    'sunland-park': {
      name: 'Sunland Park'
    },
    'las-vegas-city': {
      name: 'Las Vegas City'
    },
    portales: {
      name: 'Portales'
    },
    artesia: {
      name: 'Artesia'
    },
    lovington: {
      name: 'Lovington'
    },
    'silver-city': {
      name: 'Silver City'
    },
    espanola: {
      name: 'Espanola'
    },
    grants: {
      name: 'Grants'
    },
    socorro: {
      name: 'Socorro'
    },
    corrales: {
      name: 'Corrales'
    },
    bernalillo: {
      name: 'Bernalillo'
    },
    bloomfield: {
      name: 'Bloomfield'
    },
    ruidoso: {
      name: 'Ruidoso'
    },
    belen: {
      name: 'Belen'
    },
    raton: {
      name: 'Raton'
    },
    aztec: {
      name: 'Aztec'
    },
    'truth-or-consequences': {
      name: 'Truth Or Consequences'
    },
    'los-ranchos-de-albuquerque': {
      name: 'Los Ranchos De Albuquerque'
    },
    taos: {
      name: 'Taos'
    },
    tucumcari: {
      name: 'Tucumcari'
    },
    'bosque-farms': {
      name: 'Bosque Farms'
    },
    edgewood: {
      name: 'Edgewood'
    },
    peralta: {
      name: 'Peralta'
    },
    milan: {
      name: 'Milan'
    },
    clayton: {
      name: 'Clayton'
    },
    eunice: {
      name: 'Eunice'
    },
    'santa-rosa': {
      name: 'Santa Rosa'
    },
    tularosa: {
      name: 'Tularosa'
    },
    'ruidoso-downs': {
      name: 'Ruidoso Downs'
    },
    lordsburg: {
      name: 'Lordsburg'
    },
    bayard: {
      name: 'Bayard'
    },
    'hot-springs': {
      name: 'Hot Springs'
    },
    jal: {
      name: 'Jal'
    },
    'las-vegas-town': {
      name: 'Las Vegas Town'
    },
    'los-alamos': {
      name: 'Los Alamos'
    },
    'north-valley': {
      name: 'North Valley'
    },
    'south-valley': {
      name: 'South Valley'
    }
  },
  {
    name: 'Missouri',
    slug: 'missouri',
    abbreviation: 'MO',
    'kansas-city': {
      name: 'Kansas City'
    },
    'st.-louis': {
      name: 'St. Louis'
    },
    springfield: {
      name: 'Springfield'
    },
    independence: {
      name: 'Independence'
    },
    columbia: {
      name: 'Columbia'
    },
    "lee's-summit": {
      name: "Lee's Summit"
    },
    "o'fallon": {
      name: "O'Fallon"
    },
    'st.-joseph': {
      name: 'St. Joseph'
    },
    'st.-charles': {
      name: 'St. Charles'
    },
    'blue-springs': {
      name: 'Blue Springs'
    },
    'st.-peters': {
      name: 'St. Peters'
    },
    florissant: {
      name: 'Florissant'
    },
    joplin: {
      name: 'Joplin'
    },
    chesterfield: {
      name: 'Chesterfield'
    },
    'jefferson-city': {
      name: 'Jefferson City'
    },
    'cape-girardeau': {
      name: 'Cape Girardeau'
    },
    wildwood: {
      name: 'Wildwood'
    },
    'university-city': {
      name: 'University City'
    },
    ballwin: {
      name: 'Ballwin'
    },
    raytown: {
      name: 'Raytown'
    },
    liberty: {
      name: 'Liberty'
    },
    wentzville: {
      name: 'Wentzville'
    },
    kirkwood: {
      name: 'Kirkwood'
    },
    'maryland-heights': {
      name: 'Maryland Heights'
    },
    hazelwood: {
      name: 'Hazelwood'
    },
    gladstone: {
      name: 'Gladstone'
    },
    grandview: {
      name: 'Grandview'
    },
    belton: {
      name: 'Belton'
    },
    'webster-groves': {
      name: 'Webster Groves'
    },
    sedalia: {
      name: 'Sedalia'
    },
    ferguson: {
      name: 'Ferguson'
    },
    arnold: {
      name: 'Arnold'
    },
    rolla: {
      name: 'Rolla'
    },
    raymore: {
      name: 'Raymore'
    },
    nixa: {
      name: 'Nixa'
    },
    warrensburg: {
      name: 'Warrensburg'
    },
    manchester: {
      name: 'Manchester'
    },
    hannibal: {
      name: 'Hannibal'
    },
    'creve-coeur': {
      name: 'Creve Coeur'
    },
    ozark: {
      name: 'Ozark'
    },
    kirksville: {
      name: 'Kirksville'
    },
    'poplar-bluff': {
      name: 'Poplar Bluff'
    },
    sikeston: {
      name: 'Sikeston'
    },
    farmington: {
      name: 'Farmington'
    },
    overland: {
      name: 'Overland'
    },
    clayton: {
      name: 'Clayton'
    },
    republic: {
      name: 'Republic'
    },
    jennings: {
      name: 'Jennings'
    },
    'lake-saint-louis': {
      name: 'Lake Saint Louis'
    },
    lebanon: {
      name: 'Lebanon'
    }
  },
  {
    name: 'Virginia',
    slug: 'virginia',
    abbreviation: 'VA',
    'virginia-beach': {
      name: 'Virginia Beach'
    },
    norfolk: {
      name: 'Norfolk'
    },
    chesapeake: {
      name: 'Chesapeake'
    },
    richmond: {
      name: 'Richmond'
    },
    'newport-news': {
      name: 'Newport News'
    },
    alexandria: {
      name: 'Alexandria'
    },
    hampton: {
      name: 'Hampton'
    },
    roanoke: {
      name: 'Roanoke'
    },
    portsmouth: {
      name: 'Portsmouth'
    },
    suffolk: {
      name: 'Suffolk'
    },
    lynchburg: {
      name: 'Lynchburg'
    },
    harrisonburg: {
      name: 'Harrisonburg'
    },
    charlottesville: {
      name: 'Charlottesville'
    },
    danville: {
      name: 'Danville'
    },
    blacksburg: {
      name: 'Blacksburg'
    },
    leesburg: {
      name: 'Leesburg'
    },
    manassas: {
      name: 'Manassas'
    },
    petersburg: {
      name: 'Petersburg'
    },
    winchester: {
      name: 'Winchester'
    },
    salem: {
      name: 'Salem'
    },
    fredericksburg: {
      name: 'Fredericksburg'
    },
    staunton: {
      name: 'Staunton'
    },
    herndon: {
      name: 'Herndon'
    },
    hopewell: {
      name: 'Hopewell'
    },
    fairfax: {
      name: 'Fairfax'
    },
    christiansburg: {
      name: 'Christiansburg'
    },
    waynesboro: {
      name: 'Waynesboro'
    },
    bristol: {
      name: 'Bristol'
    },
    'colonial-heights': {
      name: 'Colonial Heights'
    },
    radford: {
      name: 'Radford'
    },
    culpeper: {
      name: 'Culpeper'
    },
    vienna: {
      name: 'Vienna'
    },
    'front-royal': {
      name: 'Front Royal'
    },
    'manassas-park': {
      name: 'Manassas Park'
    },
    williamsburg: {
      name: 'Williamsburg'
    },
    martinsville: {
      name: 'Martinsville'
    },
    'falls-church': {
      name: 'Falls Church'
    },
    poquoson: {
      name: 'Poquoson'
    },
    warrenton: {
      name: 'Warrenton'
    },
    pulaski: {
      name: 'Pulaski'
    },
    franklin: {
      name: 'Franklin'
    },
    farmville: {
      name: 'Farmville'
    },
    wytheville: {
      name: 'Wytheville'
    },
    abingdon: {
      name: 'Abingdon'
    },
    'south-boston': {
      name: 'South Boston'
    },
    vinton: {
      name: 'Vinton'
    },
    smithfield: {
      name: 'Smithfield'
    },
    purcellville: {
      name: 'Purcellville'
    },
    ashland: {
      name: 'Ashland'
    },
    galax: {
      name: 'Galax'
    }
  },
  {
    name: 'Georgia',
    slug: 'georgia',
    abbreviation: 'GA',
    atlanta: {
      name: 'Atlanta'
    },
    augusta: {
      name: 'Augusta'
    },
    columbus: {
      name: 'Columbus'
    },
    savannah: {
      name: 'Savannah'
    },
    athens: {
      name: 'Athens'
    },
    'sandy-springs': {
      name: 'Sandy Springs'
    },
    macon: {
      name: 'Macon'
    },
    roswell: {
      name: 'Roswell'
    },
    albany: {
      name: 'Albany'
    },
    'johns-creek': {
      name: 'Johns Creek'
    },
    'warner-robins': {
      name: 'Warner Robins'
    },
    alpharetta: {
      name: 'Alpharetta'
    },
    marietta: {
      name: 'Marietta'
    },
    valdosta: {
      name: 'Valdosta'
    },
    smyrna: {
      name: 'Smyrna'
    },
    dunwoody: {
      name: 'Dunwoody'
    },
    rome: {
      name: 'Rome'
    },
    'peachtree-city': {
      name: 'Peachtree City'
    },
    gainesville: {
      name: 'Gainesville'
    },
    'east-point': {
      name: 'East Point'
    },
    hinesville: {
      name: 'Hinesville'
    },
    dalton: {
      name: 'Dalton'
    },
    newnan: {
      name: 'Newnan'
    },
    milton: {
      name: 'Milton'
    },
    douglasville: {
      name: 'Douglasville'
    },
    kennesaw: {
      name: 'Kennesaw'
    },
    'la-grange': {
      name: 'La Grange'
    },
    lawrenceville: {
      name: 'Lawrenceville'
    },
    statesboro: {
      name: 'Statesboro'
    },
    duluth: {
      name: 'Duluth'
    },
    stockbridge: {
      name: 'Stockbridge'
    },
    carrollton: {
      name: 'Carrollton'
    },
    woodstock: {
      name: 'Woodstock'
    },
    griffin: {
      name: 'Griffin'
    },
    canton: {
      name: 'Canton'
    },
    mcdonough: {
      name: 'Mcdonough'
    },
    acworth: {
      name: 'Acworth'
    },
    cartersville: {
      name: 'Cartersville'
    },
    'union-city': {
      name: 'Union City'
    },
    decatur: {
      name: 'Decatur'
    },
    pooler: {
      name: 'Pooler'
    },
    'sugar-hill': {
      name: 'Sugar Hill'
    },
    'forest-park': {
      name: 'Forest Park'
    },
    thomasville: {
      name: 'Thomasville'
    },
    snellville: {
      name: 'Snellville'
    },
    milledgeville: {
      name: 'Milledgeville'
    },
    'saint-marys': {
      name: 'Saint Marys'
    },
    americus: {
      name: 'Americus'
    },
    tifton: {
      name: 'Tifton'
    },
    dublin: {
      name: 'Dublin'
    }
  },
  {
    name: 'Nebraska',
    slug: 'nebraska',
    abbreviation: 'NE',
    omaha: {
      name: 'Omaha'
    },
    lincoln: {
      name: 'Lincoln'
    },
    bellevue: {
      name: 'Bellevue'
    },
    'grand-island': {
      name: 'Grand Island'
    },
    kearney: {
      name: 'Kearney'
    },
    fremont: {
      name: 'Fremont'
    },
    hastings: {
      name: 'Hastings'
    },
    'north-platte': {
      name: 'North Platte'
    },
    norfolk: {
      name: 'Norfolk'
    },
    columbus: {
      name: 'Columbus'
    },
    papillion: {
      name: 'Papillion'
    },
    'la-vista': {
      name: 'La Vista'
    },
    scottsbluff: {
      name: 'Scottsbluff'
    },
    'south-sioux-city': {
      name: 'South Sioux City'
    },
    beatrice: {
      name: 'Beatrice'
    },
    lexington: {
      name: 'Lexington'
    },
    gering: {
      name: 'Gering'
    },
    alliance: {
      name: 'Alliance'
    },
    blair: {
      name: 'Blair'
    },
    york: {
      name: 'York'
    },
    mccook: {
      name: 'Mccook'
    },
    'nebraska-city': {
      name: 'Nebraska City'
    },
    seward: {
      name: 'Seward'
    },
    crete: {
      name: 'Crete'
    },
    sidney: {
      name: 'Sidney'
    },
    plattsmouth: {
      name: 'Plattsmouth'
    },
    schuyler: {
      name: 'Schuyler'
    },
    ralston: {
      name: 'Ralston'
    },
    chadron: {
      name: 'Chadron'
    },
    wayne: {
      name: 'Wayne'
    },
    holdrege: {
      name: 'Holdrege'
    },
    ogallala: {
      name: 'Ogallala'
    },
    wahoo: {
      name: 'Wahoo'
    },
    aurora: {
      name: 'Aurora'
    },
    gretna: {
      name: 'Gretna'
    },
    'falls-city': {
      name: 'Falls City'
    },
    cozad: {
      name: 'Cozad'
    },
    fairbury: {
      name: 'Fairbury'
    },
    "o'neill": {
      name: "O'Neill"
    },
    gothenburg: {
      name: 'Gothenburg'
    },
    'broken-bow': {
      name: 'Broken Bow'
    },
    auburn: {
      name: 'Auburn'
    },
    'west-point': {
      name: 'West Point'
    },
    waverly: {
      name: 'Waverly'
    },
    'central-city': {
      name: 'Central City'
    },
    minden: {
      name: 'Minden'
    },
    'david-city': {
      name: 'David City'
    },
    valentine: {
      name: 'Valentine'
    },
    'benson-city': {
      name: 'Benson City'
    },
    elkhorn: {
      name: 'Elkhorn'
    }
  },
  {
    name: 'Hawaii',
    slug: 'hawaii',
    abbreviation: 'HI',
    honolulu: {
      name: 'Honolulu'
    },
    'pearl-city': {
      name: 'Pearl City'
    },
    hilo: {
      name: 'Hilo'
    },
    kailua: {
      name: 'Kailua'
    },
    waipahu: {
      name: 'Waipahu'
    },
    kaneohe: {
      name: 'Kaneohe'
    },
    'mililani-town': {
      name: 'Mililani Town'
    },
    kahului: {
      name: 'Kahului'
    },
    'ewa-gentry': {
      name: 'Ewa Gentry'
    },
    'mililani-mauka': {
      name: 'Mililani Mauka'
    },
    kihei: {
      name: 'Kihei'
    },
    makakilo: {
      name: 'Makakilo'
    },
    waihiawa: {
      name: 'Waihiawa'
    },
    'schofield-barracks': {
      name: 'Schofield Barracks'
    },
    wailuku: {
      name: 'Wailuku'
    },
    kapolei: {
      name: 'Kapolei'
    },
    'ewa-beach': {
      name: 'Ewa Beach'
    },
    'royal-kunia': {
      name: 'Royal Kunia'
    },
    halawa: {
      name: 'Halawa'
    },
    waimalu: {
      name: 'Waimalu'
    },
    waianae: {
      name: 'Waianae'
    },
    nanakuli: {
      name: 'Nanakuli'
    },
    lahaina: {
      name: 'Lahaina'
    },
    waipio: {
      name: 'Waipio'
    },
    'hawaiian-paradise-park': {
      name: 'Hawaiian Paradise Park'
    },
    kapaa: {
      name: 'Kapaa'
    },
    kalaoa: {
      name: 'Kalaoa'
    },
    'kaneohe-station': {
      name: 'Kaneohe Station'
    },
    maili: {
      name: 'Maili'
    },
    aiea: {
      name: 'Aiea'
    },
    waimea: {
      name: 'Waimea'
    },
    'waihee-waiehu': {
      name: 'Waihee-Waiehu'
    },
    ahuimanu: {
      name: 'Ahuimanu'
    },
    holualoa: {
      name: 'Holualoa'
    },
    'ocean-pointe': {
      name: 'Ocean Pointe'
    },
    makaha: {
      name: 'Makaha'
    },
    'haiku-pauwela': {
      name: 'Haiku-Pauwela'
    },
    pukalani: {
      name: 'Pukalani'
    },
    waikele: {
      name: 'Waikele'
    },
    'napili-honokowai': {
      name: 'Napili-Honokowai'
    },
    makawao: {
      name: 'Makawao'
    },
    'hickam-housing': {
      name: 'Hickam Housing'
    },
    lihue: {
      name: 'Lihue'
    },
    kula: {
      name: 'Kula'
    },
    'waikoloa-village': {
      name: 'Waikoloa Village'
    },
    laie: {
      name: 'Laie'
    },
    'ewa-villages': {
      name: 'Ewa Villages'
    },
    wailea: {
      name: 'Wailea'
    },
    'west-loch-estate': {
      name: 'West Loch Estate'
    },
    waimanalo: {
      name: 'Waimanalo'
    }
  },
  {
    name: 'Minnesota',
    slug: 'minnesota',
    abbreviation: 'MN',
    minneapolis: {
      name: 'Minneapolis'
    },
    'st.-paul': {
      name: 'St. Paul'
    },
    rochester: {
      name: 'Rochester'
    },
    duluth: {
      name: 'Duluth'
    },
    bloomington: {
      name: 'Bloomington'
    },
    'brooklyn-park': {
      name: 'Brooklyn Park'
    },
    plymouth: {
      name: 'Plymouth'
    },
    'st.-cloud': {
      name: 'St. Cloud'
    },
    eagan: {
      name: 'Eagan'
    },
    woodbury: {
      name: 'Woodbury'
    },
    'maple-grove': {
      name: 'Maple Grove'
    },
    'coon-rapids': {
      name: 'Coon Rapids'
    },
    'eden-prairie': {
      name: 'Eden Prairie'
    },
    burnsville: {
      name: 'Burnsville'
    },
    blaine: {
      name: 'Blaine'
    },
    lakeville: {
      name: 'Lakeville'
    },
    minnetonka: {
      name: 'Minnetonka'
    },
    'apple-valley': {
      name: 'Apple Valley'
    },
    edina: {
      name: 'Edina'
    },
    'st.-louis-park': {
      name: 'St. Louis Park'
    },
    mankato: {
      name: 'Mankato'
    },
    moorhead: {
      name: 'Moorhead'
    },
    maplewood: {
      name: 'Maplewood'
    },
    shakopee: {
      name: 'Shakopee'
    },
    richfield: {
      name: 'Richfield'
    },
    'cottage-grove': {
      name: 'Cottage Grove'
    },
    'inver-grove-heights': {
      name: 'Inver Grove Heights'
    },
    roseville: {
      name: 'Roseville'
    },
    andover: {
      name: 'Andover'
    },
    'brooklyn-center': {
      name: 'Brooklyn Center'
    },
    winona: {
      name: 'Winona'
    },
    oakdale: {
      name: 'Oakdale'
    },
    fridley: {
      name: 'Fridley'
    },
    savage: {
      name: 'Savage'
    },
    owatonna: {
      name: 'Owatonna'
    },
    shoreview: {
      name: 'Shoreview'
    },
    austin: {
      name: 'Austin'
    },
    'white-bear-lake': {
      name: 'White Bear Lake'
    },
    chaska: {
      name: 'Chaska'
    },
    ramsey: {
      name: 'Ramsey'
    },
    faribault: {
      name: 'Faribault'
    },
    champlin: {
      name: 'Champlin'
    },
    'elk-river': {
      name: 'Elk River'
    },
    chanhassen: {
      name: 'Chanhassen'
    },
    'prior-lake': {
      name: 'Prior Lake'
    },
    hastings: {
      name: 'Hastings'
    },
    crystal: {
      name: 'Crystal'
    },
    rosemount: {
      name: 'Rosemount'
    },
    'new-brighton': {
      name: 'New Brighton'
    },
    farmington: {
      name: 'Farmington'
    }
  },
  {
    name: 'Kansas',
    slug: 'kansas',
    abbreviation: 'KS',
    wichita: {
      name: 'Wichita'
    },
    'overland-park': {
      name: 'Overland Park'
    },
    'kansas-city': {
      name: 'Kansas City'
    },
    topeka: {
      name: 'Topeka'
    },
    olathe: {
      name: 'Olathe'
    },
    lawrence: {
      name: 'Lawrence'
    },
    shawnee: {
      name: 'Shawnee'
    },
    manhattan: {
      name: 'Manhattan'
    },
    lenexa: {
      name: 'Lenexa'
    },
    salina: {
      name: 'Salina'
    },
    hutchinson: {
      name: 'Hutchinson'
    },
    leavenworth: {
      name: 'Leavenworth'
    },
    leawood: {
      name: 'Leawood'
    },
    'dodge-city': {
      name: 'Dodge City'
    },
    'garden-city': {
      name: 'Garden City'
    },
    emporia: {
      name: 'Emporia'
    },
    'junction-city': {
      name: 'Junction City'
    },
    derby: {
      name: 'Derby'
    },
    'prairie-village': {
      name: 'Prairie Village'
    },
    liberal: {
      name: 'Liberal'
    },
    hays: {
      name: 'Hays'
    },
    pittsburg: {
      name: 'Pittsburg'
    },
    newton: {
      name: 'Newton'
    },
    gardner: {
      name: 'Gardner'
    },
    'great-bend': {
      name: 'Great Bend'
    },
    mcpherson: {
      name: 'Mcpherson'
    },
    'el-dorado': {
      name: 'El Dorado'
    },
    ottawa: {
      name: 'Ottawa'
    },
    'arkansas-city': {
      name: 'Arkansas City'
    },
    winfield: {
      name: 'Winfield'
    },
    andover: {
      name: 'Andover'
    },
    lansing: {
      name: 'Lansing'
    },
    atchison: {
      name: 'Atchison'
    },
    merriam: {
      name: 'Merriam'
    },
    haysville: {
      name: 'Haysville'
    },
    parsons: {
      name: 'Parsons'
    },
    coffeyville: {
      name: 'Coffeyville'
    },
    independence: {
      name: 'Independence'
    },
    mission: {
      name: 'Mission'
    },
    augusta: {
      name: 'Augusta'
    },
    chanute: {
      name: 'Chanute'
    },
    wellington: {
      name: 'Wellington'
    },
    'fort-scott': {
      name: 'Fort Scott'
    },
    'bonner-springs': {
      name: 'Bonner Springs'
    },
    'park-city': {
      name: 'Park City'
    },
    abilene: {
      name: 'Abilene'
    },
    pratt: {
      name: 'Pratt'
    },
    'valley-center': {
      name: 'Valley Center'
    },
    'bel-aire': {
      name: 'Bel Aire'
    },
    'roeland-park': {
      name: 'Roeland Park'
    }
  },
  {
    name: 'Louisiana',
    slug: 'louisiana',
    abbreviation: 'LA',
    'new-orleans': {
      name: 'New Orleans'
    },
    'baton-rouge': {
      name: 'Baton Rouge'
    },
    shreveport: {
      name: 'Shreveport'
    },
    lafayette: {
      name: 'Lafayette'
    },
    'lake-charles': {
      name: 'Lake Charles'
    },
    kenner: {
      name: 'Kenner'
    },
    'bossier-city': {
      name: 'Bossier City'
    },
    monroe: {
      name: 'Monroe'
    },
    alexandria: {
      name: 'Alexandria'
    },
    houma: {
      name: 'Houma'
    },
    'new-iberia': {
      name: 'New Iberia'
    },
    slidell: {
      name: 'Slidell'
    },
    central: {
      name: 'Central'
    },
    ruston: {
      name: 'Ruston'
    },
    sulphur: {
      name: 'Sulphur'
    },
    hammond: {
      name: 'Hammond'
    },
    natchitoches: {
      name: 'Natchitoches'
    },
    gretna: {
      name: 'Gretna'
    },
    opelousas: {
      name: 'Opelousas'
    },
    zachary: {
      name: 'Zachary'
    },
    thibodeaux: {
      name: 'Thibodeaux'
    },
    pineville: {
      name: 'Pineville'
    },
    baker: {
      name: 'Baker'
    },
    crowley: {
      name: 'Crowley'
    },
    minden: {
      name: 'Minden'
    },
    'west-monroe': {
      name: 'West Monroe'
    },
    'morgan-city': {
      name: 'Morgan City'
    },
    abbeville: {
      name: 'Abbeville'
    },
    bogalusa: {
      name: 'Bogalusa'
    },
    mandeville: {
      name: 'Mandeville'
    },
    bastrop: {
      name: 'Bastrop'
    },
    deridder: {
      name: 'DeRidder'
    },
    eunice: {
      name: 'Eunice'
    },
    jennings: {
      name: 'Jennings'
    },
    'denham-springs': {
      name: 'Denham Springs'
    },
    gonzales: {
      name: 'Gonzales'
    },
    harahan: {
      name: 'Harahan'
    },
    covington: {
      name: 'Covington'
    },
    scott: {
      name: 'Scott'
    },
    westwego: {
      name: 'Westwego'
    },
    broussard: {
      name: 'Broussard'
    },
    'breaux-bridge': {
      name: 'Breaux Bridge'
    },
    youngsville: {
      name: 'Youngsville'
    },
    rayne: {
      name: 'Rayne'
    },
    oakdale: {
      name: 'Oakdale'
    },
    franklin: {
      name: 'Franklin'
    },
    carencro: {
      name: 'Carencro'
    },
    donaldsonville: {
      name: 'Donaldsonville'
    },
    'ville-platte': {
      name: 'Ville Platte'
    },
    tallulah: {
      name: 'Tallulah'
    }
  },
  {
    name: 'Alaska',
    slug: 'alaska',
    abbreviation: 'AK',
    anchorage: {
      name: 'Anchorage'
    },
    fairbanks: {
      name: 'Fairbanks'
    },
    juneau: {
      name: 'Juneau'
    },
    sitka: {
      name: 'Sitka'
    },
    ketchikan: {
      name: 'Ketchikan'
    },
    wasilla: {
      name: 'Wasilla'
    },
    kenai: {
      name: 'Kenai'
    },
    kodiak: {
      name: 'Kodiak'
    },
    bethel: {
      name: 'Bethel'
    },
    palmer: {
      name: 'Palmer'
    },
    homer: {
      name: 'Homer'
    },
    unalaska: {
      name: 'Unalaska'
    },
    barrow: {
      name: 'Barrow'
    },
    soldotna: {
      name: 'Soldotna'
    },
    valdez: {
      name: 'Valdez'
    },
    nome: {
      name: 'Nome'
    },
    kotzebue: {
      name: 'Kotzebue'
    },
    petersburg: {
      name: 'Petersburg'
    },
    seward: {
      name: 'Seward'
    },
    skagway: {
      name: 'Skagway'
    },
    college: {
      name: 'College'
    },
    cordova: {
      name: 'Cordova'
    },
    douglas: {
      name: 'Douglas'
    },
    haines: {
      name: 'Haines'
    },
    metlakatla: {
      name: 'Metlakatla'
    },
    nikishka: {
      name: 'Nikishka'
    },
    spenard: {
      name: 'Spenard'
    },
    wrangell: {
      name: 'Wrangell'
    }
  },
  {
    name: 'New Jersey',
    slug: 'new-jersey',
    abbreviation: 'NJ',
    newark: {
      name: 'Newark'
    },
    'jersey-city': {
      name: 'Jersey City'
    },
    paterson: {
      name: 'Paterson'
    },
    elizabeth: {
      name: 'Elizabeth'
    },
    trenton: {
      name: 'Trenton'
    },
    clifton: {
      name: 'Clifton'
    },
    camden: {
      name: 'Camden'
    },
    passaic: {
      name: 'Passaic'
    },
    'union-city': {
      name: 'Union City'
    },
    'east-orange': {
      name: 'East Orange'
    },
    bayonne: {
      name: 'Bayonne'
    },
    vineland: {
      name: 'Vineland'
    },
    'new-brunswick': {
      name: 'New Brunswick'
    },
    'perth-amboy': {
      name: 'Perth Amboy'
    },
    hoboken: {
      name: 'Hoboken'
    },
    plainfield: {
      name: 'Plainfield'
    },
    'west-new-york': {
      name: 'West New York'
    },
    hackensack: {
      name: 'Hackensack'
    },
    sayreville: {
      name: 'Sayreville'
    },
    kearny: {
      name: 'Kearny'
    },
    linden: {
      name: 'Linden'
    },
    'atlantic-city': {
      name: 'Atlantic City'
    },
    'fort-lee': {
      name: 'Fort Lee'
    },
    'fair-lawn': {
      name: 'Fair Lawn'
    },
    'long-branch': {
      name: 'Long Branch'
    },
    garfield: {
      name: 'Garfield'
    },
    westfield: {
      name: 'Westfield'
    },
    millville: {
      name: 'Millville'
    },
    rahway: {
      name: 'Rahway'
    },
    englewood: {
      name: 'Englewood'
    },
    bergenfield: {
      name: 'Bergenfield'
    },
    paramus: {
      name: 'Paramus'
    },
    bridgeton: {
      name: 'Bridgeton'
    },
    ridgewood: {
      name: 'Ridgewood'
    },
    lodi: {
      name: 'Lodi'
    },
    'cliffside-park': {
      name: 'Cliffside Park'
    },
    'south-plainfield': {
      name: 'South Plainfield'
    },
    carteret: {
      name: 'Carteret'
    },
    'north-plainfield': {
      name: 'North Plainfield'
    },
    summit: {
      name: 'Summit'
    },
    roselle: {
      name: 'Roselle'
    },
    pleasantville: {
      name: 'Pleasantville'
    },
    'palisades-park': {
      name: 'Palisades Park'
    },
    'elmwood-park': {
      name: 'Elmwood Park'
    },
    hawthorne: {
      name: 'Hawthorne'
    },
    glassboro: {
      name: 'Glassboro'
    },
    morristown: {
      name: 'Morristown'
    },
    'point-pleasant': {
      name: 'Point Pleasant'
    },
    dover: {
      name: 'Dover'
    },
    rutherford: {
      name: 'Rutherford'
    }
  },
  {
    name: 'Alabama',
    slug: 'alabama',
    abbreviation: 'AL',
    birmingham: {
      name: 'Birmingham'
    },
    montgomery: {
      name: 'Montgomery'
    },
    mobile: {
      name: 'Mobile'
    },
    huntsville: {
      name: 'Huntsville'
    },
    tuscaloosa: {
      name: 'Tuscaloosa'
    },
    hoover: {
      name: 'Hoover'
    },
    dothan: {
      name: 'Dothan'
    },
    decatur: {
      name: 'Decatur'
    },
    auburn: {
      name: 'Auburn'
    },
    madison: {
      name: 'Madison'
    },
    florence: {
      name: 'Florence'
    },
    gadsden: {
      name: 'Gadsden'
    },
    'vestavia-hills': {
      name: 'Vestavia Hills'
    },
    prattville: {
      name: 'Prattville'
    },
    'phenix-city': {
      name: 'Phenix City'
    },
    alabaster: {
      name: 'Alabaster'
    },
    bessemer: {
      name: 'Bessemer'
    },
    enterprise: {
      name: 'Enterprise'
    },
    opelika: {
      name: 'Opelika'
    },
    homewood: {
      name: 'Homewood'
    },
    northport: {
      name: 'Northport'
    },
    anniston: {
      name: 'Anniston'
    },
    prichard: {
      name: 'Prichard'
    },
    athens: {
      name: 'Athens'
    },
    daphne: {
      name: 'Daphne'
    },
    pelham: {
      name: 'Pelham'
    },
    oxford: {
      name: 'Oxford'
    },
    albertville: {
      name: 'Albertville'
    },
    selma: {
      name: 'Selma'
    },
    'mountain-brook': {
      name: 'Mountain Brook'
    },
    trussville: {
      name: 'Trussville'
    },
    troy: {
      name: 'Troy'
    },
    'center-point': {
      name: 'Center Point'
    },
    helena: {
      name: 'Helena'
    },
    hueytown: {
      name: 'Hueytown'
    },
    talladega: {
      name: 'Talladega'
    },
    fairhope: {
      name: 'Fairhope'
    },
    ozark: {
      name: 'Ozark'
    },
    'alexander-city': {
      name: 'Alexander City'
    },
    cullman: {
      name: 'Cullman'
    },
    scottsboro: {
      name: 'Scottsboro'
    },
    millbrook: {
      name: 'Millbrook'
    },
    foley: {
      name: 'Foley'
    },
    jasper: {
      name: 'Jasper'
    },
    hartselle: {
      name: 'Hartselle'
    },
    'fort-payne': {
      name: 'Fort Payne'
    },
    gardendale: {
      name: 'Gardendale'
    },
    saraland: {
      name: 'Saraland'
    },
    'muscle-shoals': {
      name: 'Muscle Shoals'
    },
    eufaula: {
      name: 'Eufaula'
    }
  },
  {
    name: 'Idaho',
    slug: 'idaho',
    abbreviation: 'ID',
    boise: {
      name: 'Boise'
    },
    nampa: {
      name: 'Nampa'
    },
    meridian: {
      name: 'Meridian'
    },
    'idaho-falls': {
      name: 'Idaho Falls'
    },
    pocatello: {
      name: 'Pocatello'
    },
    caldwell: {
      name: 'Caldwell'
    },
    "coeur-d'alene": {
      name: "Coeur D'Alene"
    },
    'twin-falls': {
      name: 'Twin Falls'
    },
    lewiston: {
      name: 'Lewiston'
    },
    'post-falls': {
      name: 'Post Falls'
    },
    rexburg: {
      name: 'Rexburg'
    },
    moscow: {
      name: 'Moscow'
    },
    eagle: {
      name: 'Eagle'
    },
    kuna: {
      name: 'Kuna'
    },
    'mountain-home': {
      name: 'Mountain Home'
    },
    chubbuck: {
      name: 'Chubbuck'
    },
    ammon: {
      name: 'Ammon'
    },
    hayden: {
      name: 'Hayden'
    },
    blackfoot: {
      name: 'Blackfoot'
    },
    'garden-city': {
      name: 'Garden City'
    },
    jerome: {
      name: 'Jerome'
    },
    burley: {
      name: 'Burley'
    },
    hailey: {
      name: 'Hailey'
    },
    payette: {
      name: 'Payette'
    },
    sandpoint: {
      name: 'Sandpoint'
    },
    rathdrum: {
      name: 'Rathdrum'
    },
    emmett: {
      name: 'Emmett'
    },
    star: {
      name: 'Star'
    },
    rupert: {
      name: 'Rupert'
    },
    middleton: {
      name: 'Middleton'
    },
    weiser: {
      name: 'Weiser'
    },
    preston: {
      name: 'Preston'
    },
    fruitland: {
      name: 'Fruitland'
    },
    'american-falls': {
      name: 'American Falls'
    },
    shelley: {
      name: 'Shelley'
    },
    buhl: {
      name: 'Buhl'
    },
    rigby: {
      name: 'Rigby'
    },
    gooding: {
      name: 'Gooding'
    },
    'st.-anthony': {
      name: 'St. Anthony'
    },
    kimberly: {
      name: 'Kimberly'
    },
    orofino: {
      name: 'Orofino'
    },
    grangeville: {
      name: 'Grangeville'
    },
    salmon: {
      name: 'Salmon'
    },
    heyburn: {
      name: 'Heyburn'
    },
    'soda-springs': {
      name: 'Soda Springs'
    },
    mccall: {
      name: 'McCall'
    },
    wendell: {
      name: 'Wendell'
    },
    ketchum: {
      name: 'Ketchum'
    },
    homedale: {
      name: 'Homedale'
    },
    montpelier: {
      name: 'Montpelier'
    }
  },
  {
    name: 'Iowa',
    slug: 'iowa',
    abbreviation: 'IA',
    'des-moines': {
      name: 'Des Moines'
    },
    'cedar-rapids': {
      name: 'Cedar Rapids'
    },
    davenport: {
      name: 'Davenport'
    },
    'sioux-city': {
      name: 'Sioux City'
    },
    waterloo: {
      name: 'Waterloo'
    },
    'iowa-city': {
      name: 'Iowa City'
    },
    'council-bluffs': {
      name: 'Council Bluffs'
    },
    ames: {
      name: 'Ames'
    },
    dubuque: {
      name: 'Dubuque'
    },
    'west-des-moines': {
      name: 'West Des Moines'
    },
    ankeny: {
      name: 'Ankeny'
    },
    urbandale: {
      name: 'Urbandale'
    },
    'cedar-falls': {
      name: 'Cedar Falls'
    },
    marion: {
      name: 'Marion'
    },
    bettendorf: {
      name: 'Bettendorf'
    },
    'mason-city': {
      name: 'Mason City'
    },
    marshalltown: {
      name: 'Marshalltown'
    },
    clinton: {
      name: 'Clinton'
    },
    burlington: {
      name: 'Burlington'
    },
    'fort-dodge': {
      name: 'Fort Dodge'
    },
    ottumwa: {
      name: 'Ottumwa'
    },
    muscatine: {
      name: 'Muscatine'
    },
    coralville: {
      name: 'Coralville'
    },
    johnston: {
      name: 'Johnston'
    },
    clive: {
      name: 'Clive'
    },
    newton: {
      name: 'Newton'
    },
    indianola: {
      name: 'Indianola'
    },
    altoona: {
      name: 'Altoona'
    },
    waukee: {
      name: 'Waukee'
    },
    'north-liberty': {
      name: 'North Liberty'
    },
    boone: {
      name: 'Boone'
    },
    oskaloosa: {
      name: 'Oskaloosa'
    },
    spencer: {
      name: 'Spencer'
    },
    'fort-madison': {
      name: 'Fort Madison'
    },
    keokuk: {
      name: 'Keokuk'
    },
    'storm-lake': {
      name: 'Storm Lake'
    },
    pella: {
      name: 'Pella'
    },
    carroll: {
      name: 'Carroll'
    },
    waverly: {
      name: 'Waverly'
    },
    'le-mars': {
      name: 'Le Mars'
    },
    fairfield: {
      name: 'Fairfield'
    },
    grinnell: {
      name: 'Grinnell'
    },
    norwalk: {
      name: 'Norwalk'
    },
    'pleasant-hill': {
      name: 'Pleasant Hill'
    },
    'mount-pleasant': {
      name: 'Mount Pleasant'
    },
    denison: {
      name: 'Denison'
    },
    grimes: {
      name: 'Grimes'
    },
    decorah: {
      name: 'Decorah'
    },
    'webster-city': {
      name: 'Webster City'
    },
    creston: {
      name: 'Creston'
    }
  },
  {
    name: 'Arkansas',
    slug: 'arkansas',
    abbreviation: 'AR',
    'little-rock': {
      name: 'Little Rock'
    },
    'fort-smith': {
      name: 'Fort Smith'
    },
    fayetteville: {
      name: 'Fayetteville'
    },
    springdale: {
      name: 'Springdale'
    },
    jonesboro: {
      name: 'Jonesboro'
    },
    'north-little-rock': {
      name: 'North Little Rock'
    },
    conway: {
      name: 'Conway'
    },
    rogers: {
      name: 'Rogers'
    },
    'pine-bluff': {
      name: 'Pine Bluff'
    },
    bentonville: {
      name: 'Bentonville'
    },
    'hot-springs': {
      name: 'Hot Springs'
    },
    benton: {
      name: 'Benton'
    },
    texarkana: {
      name: 'Texarkana'
    },
    sherwood: {
      name: 'Sherwood'
    },
    jacksonville: {
      name: 'Jacksonville'
    },
    russellville: {
      name: 'Russellville'
    },
    'bella-vista': {
      name: 'Bella Vista'
    },
    'west-memphis': {
      name: 'West Memphis'
    },
    paragould: {
      name: 'Paragould'
    },
    cabot: {
      name: 'Cabot'
    },
    searcy: {
      name: 'Searcy'
    },
    'van-buren': {
      name: 'Van Buren'
    },
    'el-dorado': {
      name: 'El Dorado'
    },
    maumelle: {
      name: 'Maumelle'
    },
    bryant: {
      name: 'Bryant'
    },
    blytheville: {
      name: 'Blytheville'
    },
    'forrest-city': {
      name: 'Forrest City'
    },
    'siloam-springs': {
      name: 'Siloam Springs'
    },
    harrison: {
      name: 'Harrison'
    },
    'mountain-home': {
      name: 'Mountain Home'
    },
    marion: {
      name: 'Marion'
    },
    'helena-west-helena': {
      name: 'Helena-West Helena'
    },
    camden: {
      name: 'Camden'
    },
    magnolia: {
      name: 'Magnolia'
    },
    arkadelphia: {
      name: 'Arkadelphia'
    },
    malvern: {
      name: 'Malvern'
    },
    batesville: {
      name: 'Batesville'
    },
    hope: {
      name: 'Hope'
    },
    centerton: {
      name: 'Centerton'
    },
    monticello: {
      name: 'Monticello'
    },
    stuttgart: {
      name: 'Stuttgart'
    },
    clarksville: {
      name: 'Clarksville'
    },
    greenwood: {
      name: 'Greenwood'
    },
    wynne: {
      name: 'Wynne'
    },
    newport: {
      name: 'Newport'
    },
    osceola: {
      name: 'Osceola'
    },
    lowell: {
      name: 'Lowell'
    },
    beebe: {
      name: 'Beebe'
    },
    trumann: {
      name: 'Trumann'
    },
    'heber-springs': {
      name: 'Heber Springs'
    }
  },
  {
    name: 'Utah',
    slug: 'utah',
    abbreviation: 'UT',
    'salt-lake-city': {
      name: 'Salt Lake City'
    },
    'west-valley-city': {
      name: 'West Valley City'
    },
    provo: {
      name: 'Provo'
    },
    'west-jordan': {
      name: 'West Jordan'
    },
    orem: {
      name: 'Orem'
    },
    sandy: {
      name: 'Sandy'
    },
    ogden: {
      name: 'Ogden'
    },
    'st.-george': {
      name: 'St. George'
    },
    layton: {
      name: 'Layton'
    },
    taylorsville: {
      name: 'Taylorsville'
    },
    'south-jordan': {
      name: 'South Jordan'
    },
    logan: {
      name: 'Logan'
    },
    lehi: {
      name: 'Lehi'
    },
    murray: {
      name: 'Murray'
    },
    bountiful: {
      name: 'Bountiful'
    },
    draper: {
      name: 'Draper'
    },
    riverton: {
      name: 'Riverton'
    },
    roy: {
      name: 'Roy'
    },
    'spanish-fork': {
      name: 'Spanish Fork'
    },
    'pleasant-grove': {
      name: 'Pleasant Grove'
    },
    'cottonwood-heights': {
      name: 'Cottonwood Heights'
    },
    tooele: {
      name: 'Tooele'
    },
    clearfield: {
      name: 'Clearfield'
    },
    springville: {
      name: 'Springville'
    },
    'cedar-city': {
      name: 'Cedar City'
    },
    midvale: {
      name: 'Midvale'
    },
    kaysville: {
      name: 'Kaysville'
    },
    holladay: {
      name: 'Holladay'
    },
    'american-fork': {
      name: 'American Fork'
    },
    syracuse: {
      name: 'Syracuse'
    },
    'south-salt-lake': {
      name: 'South Salt Lake'
    },
    herriman: {
      name: 'Herriman'
    },
    'eagle-mountain': {
      name: 'Eagle Mountain'
    },
    clinton: {
      name: 'Clinton'
    },
    washington: {
      name: 'Washington'
    },
    payson: {
      name: 'Payson'
    },
    farmington: {
      name: 'Farmington'
    },
    brigham: {
      name: 'Brigham'
    },
    'saratoga-springs': {
      name: 'Saratoga Springs'
    },
    'north-ogden': {
      name: 'North Ogden'
    },
    'south-ogden': {
      name: 'South Ogden'
    },
    'north-salt-lake': {
      name: 'North Salt Lake'
    },
    highland: {
      name: 'Highland'
    },
    centerville: {
      name: 'Centerville'
    },
    hurricane: {
      name: 'Hurricane'
    },
    heber: {
      name: 'Heber'
    },
    'west-haven': {
      name: 'West Haven'
    },
    lindon: {
      name: 'Lindon'
    },
    'cedar-hills': {
      name: 'Cedar Hills'
    },
    'woods-cross': {
      name: 'Woods Cross'
    }
  },
  {
    name: 'Rhode Island',
    slug: 'rhode-island',
    abbreviation: 'RI',
    providence: {
      name: 'Providence'
    },
    warwick: {
      name: 'Warwick'
    },
    cranston: {
      name: 'Cranston'
    },
    pawtucket: {
      name: 'Pawtucket'
    },
    'east-providence': {
      name: 'East Providence'
    },
    woonsocket: {
      name: 'Woonsocket'
    },
    newport: {
      name: 'Newport'
    },
    'central-falls': {
      name: 'Central Falls'
    },
    barrington: {
      name: 'Barrington'
    },
    bristol: {
      name: 'Bristol'
    },
    burrillville: {
      name: 'Burrillville'
    },
    cumberland: {
      name: 'Cumberland'
    },
    'east-greenwich': {
      name: 'East Greenwich'
    },
    'fall-river': {
      name: 'Fall River'
    },
    johnston: {
      name: 'Johnston'
    },
    lincoln: {
      name: 'Lincoln'
    },
    'north-providence': {
      name: 'North Providence'
    },
    warren: {
      name: 'Warren'
    },
    'west-warwick': {
      name: 'West Warwick'
    },
    westerly: {
      name: 'Westerly'
    },
    coventry: {
      name: 'Coventry'
    },
    middletown: {
      name: 'Middletown'
    },
    'north-kingstown': {
      name: 'North Kingstown'
    },
    smithfield: {
      name: 'Smithfield'
    },
    'south-kingstown': {
      name: 'South Kingstown'
    },
    'westerly-center': {
      name: 'Westerly Center'
    }
  },
  {
    name: 'Mississippi',
    slug: 'mississippi',
    abbreviation: 'MS',
    jackson: {
      name: 'Jackson'
    },
    gulfport: {
      name: 'Gulfport'
    },
    southaven: {
      name: 'Southaven'
    },
    hattiesburg: {
      name: 'Hattiesburg'
    },
    biloxi: {
      name: 'Biloxi'
    },
    meridian: {
      name: 'Meridian'
    },
    tupelo: {
      name: 'Tupelo'
    },
    greenville: {
      name: 'Greenville'
    },
    'olive-branch': {
      name: 'Olive Branch'
    },
    'horn-lake': {
      name: 'Horn Lake'
    },
    clinton: {
      name: 'Clinton'
    },
    pearl: {
      name: 'Pearl'
    },
    madison: {
      name: 'Madison'
    },
    ridgeland: {
      name: 'Ridgeland'
    },
    starkville: {
      name: 'Starkville'
    },
    vicksburg: {
      name: 'Vicksburg'
    },
    columbus: {
      name: 'Columbus'
    },
    pascagoula: {
      name: 'Pascagoula'
    },
    brandon: {
      name: 'Brandon'
    },
    oxford: {
      name: 'Oxford'
    },
    gautier: {
      name: 'Gautier'
    },
    laurel: {
      name: 'Laurel'
    },
    clarksdale: {
      name: 'Clarksdale'
    },
    'ocean-springs': {
      name: 'Ocean Springs'
    },
    natchez: {
      name: 'Natchez'
    },
    greenwood: {
      name: 'Greenwood'
    },
    'long-beach': {
      name: 'Long Beach'
    },
    corinth: {
      name: 'Corinth'
    },
    hernando: {
      name: 'Hernando'
    },
    'moss-point': {
      name: 'Moss Point'
    },
    canton: {
      name: 'Canton'
    },
    grenada: {
      name: 'Grenada'
    },
    mccomb: {
      name: 'Mccomb'
    },
    brookhaven: {
      name: 'Brookhaven'
    },
    cleveland: {
      name: 'Cleveland'
    },
    byram: {
      name: 'Byram'
    },
    'yazoo-city': {
      name: 'Yazoo City'
    },
    'west-point': {
      name: 'West Point'
    },
    picayune: {
      name: 'Picayune'
    },
    indianola: {
      name: 'Indianola'
    },
    petal: {
      name: 'Petal'
    },
    "d'iberville": {
      name: "D'Iberville"
    },
    'bay-st.-louis': {
      name: 'Bay St. Louis'
    },
    booneville: {
      name: 'Booneville'
    },
    senatobia: {
      name: 'Senatobia'
    },
    'new-albany': {
      name: 'New Albany'
    },
    flowood: {
      name: 'Flowood'
    },
    'holly-springs': {
      name: 'Holly Springs'
    },
    philadelphia: {
      name: 'Philadelphia'
    },
    batesville: {
      name: 'Batesville'
    }
  },
  {
    name: 'South Dakota',
    slug: 'south-dakota',
    abbreviation: 'SD',
    'sioux-falls': {
      name: 'Sioux Falls'
    },
    'rapid-city': {
      name: 'Rapid City'
    },
    aberdeen: {
      name: 'Aberdeen'
    },
    brookings: {
      name: 'Brookings'
    },
    watertown: {
      name: 'Watertown'
    },
    mitchell: {
      name: 'Mitchell'
    },
    yankton: {
      name: 'Yankton'
    },
    pierre: {
      name: 'Pierre'
    },
    huron: {
      name: 'Huron'
    },
    vermillion: {
      name: 'Vermillion'
    },
    spearfish: {
      name: 'Spearfish'
    },
    brandon: {
      name: 'Brandon'
    },
    'box-elder': {
      name: 'Box Elder'
    },
    sturgis: {
      name: 'Sturgis'
    },
    madison: {
      name: 'Madison'
    },
    'belle-fourche': {
      name: 'Belle Fourche'
    },
    harrisburg: {
      name: 'Harrisburg'
    },
    tea: {
      name: 'Tea'
    },
    'hot-springs': {
      name: 'Hot Springs'
    },
    'dell-rapids': {
      name: 'Dell Rapids'
    },
    mobridge: {
      name: 'Mobridge'
    },
    milbank: {
      name: 'Milbank'
    },
    lead: {
      name: 'Lead'
    },
    canton: {
      name: 'Canton'
    },
    winner: {
      name: 'Winner'
    },
    hartford: {
      name: 'Hartford'
    },
    'north-sioux-city': {
      name: 'North Sioux City'
    },
    chamberlain: {
      name: 'Chamberlain'
    },
    deadwood: {
      name: 'Deadwood'
    },
    'fort-pierre': {
      name: 'Fort Pierre'
    },
    lemmon: {
      name: 'Lemmon'
    },
    redfield: {
      name: 'Redfield'
    },
    sisseton: {
      name: 'Sisseton'
    },
    webster: {
      name: 'Webster'
    }
  },
  {
    name: 'Connecticut',
    slug: 'connecticut',
    abbreviation: 'CT',
    bridgeport: {
      name: 'Bridgeport'
    },
    'new-haven': {
      name: 'New Haven'
    },
    hartford: {
      name: 'Hartford'
    },
    stamford: {
      name: 'Stamford'
    },
    waterbury: {
      name: 'Waterbury'
    },
    norwalk: {
      name: 'Norwalk'
    },
    danbury: {
      name: 'Danbury'
    },
    'new-britain': {
      name: 'New Britain'
    },
    meriden: {
      name: 'Meriden'
    },
    bristol: {
      name: 'Bristol'
    },
    'west-haven': {
      name: 'West Haven'
    },
    milford: {
      name: 'Milford'
    },
    middletown: {
      name: 'Middletown'
    },
    norwich: {
      name: 'Norwich'
    },
    shelton: {
      name: 'Shelton'
    },
    torrington: {
      name: 'Torrington'
    },
    naugatuck: {
      name: 'Naugatuck'
    },
    'new-london': {
      name: 'New London'
    },
    ansonia: {
      name: 'Ansonia'
    },
    derby: {
      name: 'Derby'
    },
    groton: {
      name: 'Groton'
    },
    danielson: {
      name: 'Danielson'
    },
    'jewett-city': {
      name: 'Jewett City'
    },
    bethel: {
      name: 'Bethel'
    },
    birmingham: {
      name: 'Birmingham'
    },
    branford: {
      name: 'Branford'
    },
    colchester: {
      name: 'Colchester'
    },
    danielsonville: {
      name: 'Danielsonville'
    },
    'east-hartford': {
      name: 'East Hartford'
    },
    greenwich: {
      name: 'Greenwich'
    },
    putnam: {
      name: 'Putnam'
    },
    rockville: {
      name: 'Rockville'
    },
    'south-norwalk': {
      name: 'South Norwalk'
    },
    southington: {
      name: 'Southington'
    },
    'stafford-springs': {
      name: 'Stafford Springs'
    },
    stratford: {
      name: 'Stratford'
    },
    wallingford: {
      name: 'Wallingford'
    },
    'west-hartford': {
      name: 'West Hartford'
    },
    willimantic: {
      name: 'Willimantic'
    },
    winstead: {
      name: 'Winstead'
    },
    'central-manchester': {
      name: 'Central Manchester'
    },
    cheshire: {
      name: 'Cheshire'
    },
    'east-haven': {
      name: 'East Haven'
    },
    enfield: {
      name: 'Enfield'
    },
    fairfield: {
      name: 'Fairfield'
    },
    farmington: {
      name: 'Farmington'
    },
    glastonbury: {
      name: 'Glastonbury'
    },
    guilford: {
      name: 'Guilford'
    },
    hamden: {
      name: 'Hamden'
    },
    manchester: {
      name: 'Manchester'
    }
  },
  {
    name: 'South Carolina',
    slug: 'south-carolina',
    abbreviation: 'SC',
    columbia: {
      name: 'Columbia'
    },
    charleston: {
      name: 'Charleston'
    },
    'north-charleston': {
      name: 'North Charleston'
    },
    'mount-pleasant': {
      name: 'Mount Pleasant'
    },
    'rock-hill': {
      name: 'Rock Hill'
    },
    greenville: {
      name: 'Greenville'
    },
    summerville: {
      name: 'Summerville'
    },
    sumter: {
      name: 'Sumter'
    },
    'hilton-head-island': {
      name: 'Hilton Head Island'
    },
    florence: {
      name: 'Florence'
    },
    spartanburg: {
      name: 'Spartanburg'
    },
    'goose-creek': {
      name: 'Goose Creek'
    },
    aiken: {
      name: 'Aiken'
    },
    'myrtle-beach': {
      name: 'Myrtle Beach'
    },
    anderson: {
      name: 'Anderson'
    },
    greer: {
      name: 'Greer'
    },
    greenwood: {
      name: 'Greenwood'
    },
    mauldin: {
      name: 'Mauldin'
    },
    'north-augusta': {
      name: 'North Augusta'
    },
    easley: {
      name: 'Easley'
    },
    simpsonville: {
      name: 'Simpsonville'
    },
    hanahan: {
      name: 'Hanahan'
    },
    lexington: {
      name: 'Lexington'
    },
    conway: {
      name: 'Conway'
    },
    'west-columbia': {
      name: 'West Columbia'
    },
    orangeburg: {
      name: 'Orangeburg'
    },
    clemson: {
      name: 'Clemson'
    },
    'north-myrtle-beach': {
      name: 'North Myrtle Beach'
    },
    bluffton: {
      name: 'Bluffton'
    },
    cayce: {
      name: 'Cayce'
    },
    gaffney: {
      name: 'Gaffney'
    },
    beaufort: {
      name: 'Beaufort'
    },
    irmo: {
      name: 'Irmo'
    },
    'fort-mill': {
      name: 'Fort Mill'
    },
    'port-royal': {
      name: 'Port Royal'
    },
    'forest-acres': {
      name: 'Forest Acres'
    },
    newberry: {
      name: 'Newberry'
    },
    georgetown: {
      name: 'Georgetown'
    },
    laurens: {
      name: 'Laurens'
    },
    bennettsville: {
      name: 'Bennettsville'
    },
    lancaster: {
      name: 'Lancaster'
    },
    clinton: {
      name: 'Clinton'
    },
    union: {
      name: 'Union'
    },
    seneca: {
      name: 'Seneca'
    },
    'moncks-corner': {
      name: 'Moncks Corner'
    },
    'fountain-inn': {
      name: 'Fountain Inn'
    },
    hartsville: {
      name: 'Hartsville'
    },
    york: {
      name: 'York'
    },
    'tega-cay': {
      name: 'Tega Cay'
    },
    marion: {
      name: 'Marion'
    }
  },
  {
    name: 'New Hampshire',
    slug: 'new-hampshire',
    abbreviation: 'NH',
    manchester: {
      name: 'Manchester'
    },
    nashua: {
      name: 'Nashua'
    },
    concord: {
      name: 'Concord'
    },
    dover: {
      name: 'Dover'
    },
    rochester: {
      name: 'Rochester'
    },
    keene: {
      name: 'Keene'
    },
    portsmouth: {
      name: 'Portsmouth'
    },
    laconia: {
      name: 'Laconia'
    },
    claremont: {
      name: 'Claremont'
    },
    lebanon: {
      name: 'Lebanon'
    },
    somersworth: {
      name: 'Somersworth'
    },
    berlin: {
      name: 'Berlin'
    },
    franklin: {
      name: 'Franklin'
    },
    derry: {
      name: 'Derry'
    },
    exeter: {
      name: 'Exeter'
    },
    littleton: {
      name: 'Littleton'
    },
    milford: {
      name: 'Milford'
    },
    'nashville--town': {
      name: 'Nashville  Town'
    },
    newport: {
      name: 'Newport'
    },
    amherst: {
      name: 'Amherst'
    },
    bedford: {
      name: 'Bedford'
    },
    durham: {
      name: 'Durham'
    },
    goffstown: {
      name: 'Goffstown'
    },
    hampton: {
      name: 'Hampton'
    },
    hanover: {
      name: 'Hanover'
    },
    hooksett: {
      name: 'Hooksett'
    },
    hudson: {
      name: 'Hudson'
    },
    londonderry: {
      name: 'Londonderry'
    },
    merrimack: {
      name: 'Merrimack'
    },
    pelham: {
      name: 'Pelham'
    },
    salem: {
      name: 'Salem'
    },
    windham: {
      name: 'Windham'
    }
  },
  {
    name: 'North Dakota',
    slug: 'north-dakota',
    abbreviation: 'ND',
    fargo: {
      name: 'Fargo'
    },
    bismarck: {
      name: 'Bismarck'
    },
    'grand-forks': {
      name: 'Grand Forks'
    },
    minot: {
      name: 'Minot'
    },
    'west-fargo': {
      name: 'West Fargo'
    },
    mandan: {
      name: 'Mandan'
    },
    dickinson: {
      name: 'Dickinson'
    },
    jamestown: {
      name: 'Jamestown'
    },
    williston: {
      name: 'Williston'
    },
    wahpeton: {
      name: 'Wahpeton'
    },
    'devils-lake': {
      name: 'Devils Lake'
    },
    'valley-city': {
      name: 'Valley City'
    },
    grafton: {
      name: 'Grafton'
    },
    beulah: {
      name: 'Beulah'
    },
    rugby: {
      name: 'Rugby'
    },
    bottineau: {
      name: 'Bottineau'
    },
    carrington: {
      name: 'Carrington'
    },
    harvey: {
      name: 'Harvey'
    },
    hazen: {
      name: 'Hazen'
    },
    mayville: {
      name: 'Mayville'
    },
    'south-west-fargo': {
      name: 'South West Fargo'
    }
  },
  {
    name: 'Montana',
    slug: 'montana',
    abbreviation: 'MT',
    billings: {
      name: 'Billings'
    },
    missoula: {
      name: 'Missoula'
    },
    'great-falls': {
      name: 'Great Falls'
    },
    bozeman: {
      name: 'Bozeman'
    },
    butte: {
      name: 'Butte'
    },
    helena: {
      name: 'Helena'
    },
    kalispell: {
      name: 'Kalispell'
    },
    havre: {
      name: 'Havre'
    },
    anaconda: {
      name: 'Anaconda'
    },
    'miles-city': {
      name: 'Miles City'
    },
    belgrade: {
      name: 'Belgrade'
    },
    livingston: {
      name: 'Livingston'
    },
    laurel: {
      name: 'Laurel'
    },
    whitefish: {
      name: 'Whitefish'
    },
    lewiston: {
      name: 'Lewiston'
    },
    sidney: {
      name: 'Sidney'
    },
    glendive: {
      name: 'Glendive'
    },
    'columbia-falls': {
      name: 'Columbia Falls'
    },
    polson: {
      name: 'Polson'
    },
    hamilton: {
      name: 'Hamilton'
    },
    dillon: {
      name: 'Dillon'
    },
    hardin: {
      name: 'Hardin'
    },
    shelby: {
      name: 'Shelby'
    },
    glasgow: {
      name: 'Glasgow'
    },
    'deer-lodge': {
      name: 'Deer Lodge'
    },
    'cut-bank': {
      name: 'Cut Bank'
    },
    libby: {
      name: 'Libby'
    },
    'wolf-point': {
      name: 'Wolf Point'
    },
    conrad: {
      name: 'Conrad'
    },
    baker: {
      name: 'Baker'
    },
    forsyth: {
      name: 'Forsyth'
    },
    'red-lodge': {
      name: 'Red Lodge'
    },
    roundup: {
      name: 'Roundup'
    },
    walkerville: {
      name: 'Walkerville'
    }
  },
  {
    name: 'Delaware',
    slug: 'delaware',
    abbreviation: 'DE',
    wilmington: {
      name: 'Wilmington'
    },
    dover: {
      name: 'Dover'
    },
    newark: {
      name: 'Newark'
    },
    middletown: {
      name: 'Middletown'
    },
    smyrna: {
      name: 'Smyrna'
    },
    milford: {
      name: 'Milford'
    },
    seaford: {
      name: 'Seaford'
    },
    georgetown: {
      name: 'Georgetown'
    },
    elsmere: {
      name: 'Elsmere'
    },
    'new-castle': {
      name: 'New Castle'
    },
    millsboro: {
      name: 'Millsboro'
    },
    laurel: {
      name: 'Laurel'
    },
    harrington: {
      name: 'Harrington'
    },
    camden: {
      name: 'Camden'
    },
    clayton: {
      name: 'Clayton'
    },
    lewes: {
      name: 'Lewes'
    },
    milton: {
      name: 'Milton'
    },
    bellefonte: {
      name: 'Bellefonte'
    }
  },
  {
    name: 'Maine',
    slug: 'maine',
    abbreviation: 'ME',
    portland: {
      name: 'Portland'
    },
    lewiston: {
      name: 'Lewiston'
    },
    bangor: {
      name: 'Bangor'
    },
    'south-portland': {
      name: 'South Portland'
    },
    auburn: {
      name: 'Auburn'
    },
    biddeford: {
      name: 'Biddeford'
    },
    augusta: {
      name: 'Augusta'
    },
    saco: {
      name: 'Saco'
    },
    westbrook: {
      name: 'Westbrook'
    },
    waterville: {
      name: 'Waterville'
    },
    'presque-isle': {
      name: 'Presque Isle'
    },
    brewer: {
      name: 'Brewer'
    },
    bath: {
      name: 'Bath'
    },
    caribou: {
      name: 'Caribou'
    },
    'old-town': {
      name: 'Old Town'
    },
    ellsworth: {
      name: 'Ellsworth'
    },
    rockland: {
      name: 'Rockland'
    },
    belfast: {
      name: 'Belfast'
    },
    gardiner: {
      name: 'Gardiner'
    },
    calais: {
      name: 'Calais'
    },
    brunswick: {
      name: 'Brunswick'
    },
    eastport: {
      name: 'Eastport'
    },
    fairfield: {
      name: 'Fairfield'
    },
    'fort-fairfield': {
      name: 'Fort Fairfield'
    },
    hallowell: {
      name: 'Hallowell'
    },
    madison: {
      name: 'Madison'
    },
    'rumford-falls': {
      name: 'Rumford Falls'
    },
    falmouth: {
      name: 'Falmouth'
    },
    gorham: {
      name: 'Gorham'
    },
    kennebunk: {
      name: 'Kennebunk'
    },
    sanford: {
      name: 'Sanford'
    },
    scarborough: {
      name: 'Scarborough'
    },
    windham: {
      name: 'Windham'
    },
    york: {
      name: 'York'
    }
  },
  {
    name: 'Wyoming',
    slug: 'wyoming',
    abbreviation: 'WY',
    cheyenne: {
      name: 'Cheyenne'
    },
    casper: {
      name: 'Casper'
    },
    laramie: {
      name: 'Laramie'
    },
    gillette: {
      name: 'Gillette'
    },
    'rock-springs': {
      name: 'Rock Springs'
    },
    sheridan: {
      name: 'Sheridan'
    },
    'green-river': {
      name: 'Green River'
    },
    evanston: {
      name: 'Evanston'
    },
    riverton: {
      name: 'Riverton'
    },
    jackson: {
      name: 'Jackson'
    },
    cody: {
      name: 'Cody'
    },
    rawlins: {
      name: 'Rawlins'
    },
    lander: {
      name: 'Lander'
    },
    torrington: {
      name: 'Torrington'
    },
    powell: {
      name: 'Powell'
    },
    douglas: {
      name: 'Douglas'
    },
    worland: {
      name: 'Worland'
    },
    buffalo: {
      name: 'Buffalo'
    },
    wheatland: {
      name: 'Wheatland'
    },
    newcastle: {
      name: 'Newcastle'
    },
    mills: {
      name: 'Mills'
    },
    thermopolis: {
      name: 'Thermopolis'
    },
    kemmerer: {
      name: 'Kemmerer'
    },
    glenrock: {
      name: 'Glenrock'
    },
    evansville: {
      name: 'Evansville'
    },
    greybull: {
      name: 'Greybull'
    },
    lovell: {
      name: 'Lovell'
    }
  },
  {
    name: 'West Virginia',
    slug: 'west-virginia',
    abbreviation: 'WV',
    charleston: {
      name: 'Charleston'
    },
    huntington: {
      name: 'Huntington'
    },
    parkersburg: {
      name: 'Parkersburg'
    },
    morgantown: {
      name: 'Morgantown'
    },
    wheeling: {
      name: 'Wheeling'
    },
    weirton: {
      name: 'Weirton'
    },
    fairmont: {
      name: 'Fairmont'
    },
    beckley: {
      name: 'Beckley'
    },
    martinsburg: {
      name: 'Martinsburg'
    },
    clarksburg: {
      name: 'Clarksburg'
    },
    'south-charleston': {
      name: 'South Charleston'
    },
    'st.-albans': {
      name: 'St. Albans'
    },
    vienna: {
      name: 'Vienna'
    },
    bluefield: {
      name: 'Bluefield'
    },
    moundsville: {
      name: 'Moundsville'
    },
    bridgeport: {
      name: 'Bridgeport'
    },
    dunbar: {
      name: 'Dunbar'
    },
    'oak-hill': {
      name: 'Oak Hill'
    },
    nitro: {
      name: 'Nitro'
    },
    elkins: {
      name: 'Elkins'
    },
    princeton: {
      name: 'Princeton'
    },
    hurricane: {
      name: 'Hurricane'
    },
    buckhannon: {
      name: 'Buckhannon'
    },
    keyser: {
      name: 'Keyser'
    },
    'new-martinsville': {
      name: 'New Martinsville'
    },
    'charles-town': {
      name: 'Charles Town'
    },
    grafton: {
      name: 'Grafton'
    },
    ranson: {
      name: 'Ranson'
    },
    'point-pleasant': {
      name: 'Point Pleasant'
    },
    weston: {
      name: 'Weston'
    },
    westover: {
      name: 'Westover'
    },
    barboursville: {
      name: 'Barboursville'
    },
    ravenswood: {
      name: 'Ravenswood'
    },
    lewisburg: {
      name: 'Lewisburg'
    },
    summersville: {
      name: 'Summersville'
    },
    ripley: {
      name: 'Ripley'
    },
    kenova: {
      name: 'Kenova'
    },
    williamson: {
      name: 'Williamson'
    },
    'pleasant-valley': {
      name: 'Pleasant Valley'
    },
    madison: {
      name: 'Madison'
    },
    follansbee: {
      name: 'Follansbee'
    },
    philippi: {
      name: 'Philippi'
    },
    kingwood: {
      name: 'Kingwood'
    },
    williamstown: {
      name: 'Williamstown'
    },
    fayetteville: {
      name: 'Fayetteville'
    },
    wellsburg: {
      name: 'Wellsburg'
    },
    hinton: {
      name: 'Hinton'
    },
    'paden-city': {
      name: 'Paden City'
    },
    chester: {
      name: 'Chester'
    },
    moorefield: {
      name: 'Moorefield'
    }
  },
  {
    name: 'Vermont',
    slug: 'vermont',
    abbreviation: 'VT',
    burlington: {
      name: 'Burlington'
    },
    'south-burlington': {
      name: 'South Burlington'
    },
    rutland: {
      name: 'Rutland'
    },
    'essex-junction': {
      name: 'Essex Junction'
    },
    barre: {
      name: 'Barre'
    },
    montpelier: {
      name: 'Montpelier'
    },
    winooski: {
      name: 'Winooski'
    },
    'st.-albans': {
      name: 'St. Albans'
    },
    newport: {
      name: 'Newport'
    },
    'bellows-falls': {
      name: 'Bellows Falls'
    },
    vergennes: {
      name: 'Vergennes'
    },
    bennington: {
      name: 'Bennington'
    },
    brattleboro: {
      name: 'Brattleboro'
    },
    fairhaven: {
      name: 'Fairhaven'
    },
    middlebury: {
      name: 'Middlebury'
    },
    northfield: {
      name: 'Northfield'
    },
    proctor: {
      name: 'Proctor'
    },
    springfield: {
      name: 'Springfield'
    },
    'st.-johnsbury': {
      name: 'St. Johnsbury'
    },
    swanton: {
      name: 'Swanton'
    },
    waterbury: {
      name: 'Waterbury'
    },
    windsor: {
      name: 'Windsor'
    },
    colchester: {
      name: 'Colchester'
    },
    essex: {
      name: 'Essex'
    },
    hartford: {
      name: 'Hartford'
    }
  }
];
